import { Typography } from "@mui/material";
import { Document, Page, StyleSheet, Text, View, Font, Image, PDFViewer } from "@react-pdf/renderer";
import { any } from "prop-types";
import { useEffect, useRef } from "react";
import QRCodeStyling from "styled-qr-code";
import Barcode from 'react-barcode';
import JsBarcode from 'jsbarcode';
import { CalculateClothingMeasurementsFromBodyMeasurements, ClothingMeasurementDetailList, getQcChecklistForClothingType } from "common-ts/dist/models/UserMeasurements";
import { getClothingMeasurementsForItem } from "src/redux/OrderListRedux";
import { useAppSelector } from "src/reduxhooks";

export const chunkSubstr = (str, size) => {
    const numChunks = Math.ceil(str.length / size);
    const chunks = new Array(numChunks);

    for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
        chunks[i] = str.substr(o, size);
    }

    return chunks;
};
  
Font.registerHyphenationCallback((word) => {
if (word.length > 16) {
    return chunkSubstr(word, 14);
} else {
    return [word];
}
});

//Font.registerHyphenationCallback(word => [word]);

Font.register({ family: 'OakesGrotesk', fonts: [
    { src: "https://d31zz7s33c4k72.cloudfront.net/fonts/oakes-grotesk/OakesGrotesk-Light-2.ttf", fontWeight: 'light' },
    { src: "https://d31zz7s33c4k72.cloudfront.net/fonts/oakes-grotesk/OakesGrotesk-Regular-2.ttf"},
    { src: "https://d31zz7s33c4k72.cloudfront.net/fonts/oakes-grotesk/OakesGrotesk-Medium-2.ttf", fontWeight: 'medium' },
    { src: "https://d31zz7s33c4k72.cloudfront.net/fonts/oakes-grotesk/OakesGrotesk-SemiBold-2.ttf", fontWeight: 'semibold' },
    { src: "https://d31zz7s33c4k72.cloudfront.net/fonts/oakes-grotesk/OakesGrotesk-Bold-2.ttf", fontWeight: 'bold' },
    { src: "https://d31zz7s33c4k72.cloudfront.net/fonts/oakes-grotesk/OakesGrotesk-LightItalic-2.ttf", fontWeight: 'light', fontStyle: 'italic'},
    { src: "https://d31zz7s33c4k72.cloudfront.net/fonts/oakes-grotesk/OakesGrotesk-Italic-2.ttf", fontStyle: 'italic' },
    { src: "https://d31zz7s33c4k72.cloudfront.net/fonts/oakes-grotesk/OakesGrotesk-MediumItalic-2.ttf", fontWeight: 'medium', fontStyle: 'italic' },
    { src: "https://d31zz7s33c4k72.cloudfront.net/fonts/oakes-grotesk/OakesGrotesk-SemiBoldItalic-2.ttf", fontWeight: 'semibold', fontStyle: 'italic' },
    { src: "https://d31zz7s33c4k72.cloudfront.net/fonts/oakes-grotesk/OakesGrotesk-BoldItalic-2.ttf", fontWeight: 'bold', fontStyle: 'italic' },
   ]});

const styles = StyleSheet.create({
    pdfViewBrowser: {
        height: "100%",
    },
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        padding: 25,
        lineHeight: 1.5,
        flexDirection: 'column',
    },
    section: {
        margin: 5,
    },
    pageBackground: {
        position: 'absolute',
        minWidth: '100%',
        minHeight: '98%',
        height: '98%',
        width: '100%',
    },
    pageShipping: {
        width: 232,
        height: 212
    },
    pageBackgroundShipping: {
        position: 'absolute',
        minWidth: '100%',
        minHeight: '99.99%',
        height: '99.99%',
        width: '100%',
    },
    addressLabelPenerima: {
        position: 'absolute',
        left: '31.22vw',
        top: '21.85vh',
        width: '58vw',
        maxLines: 1,
        textOverflow: "ellipsis",
    },
    addressLabelPengirim: {
        position: 'absolute',
        left: '31.22vw',
        top: '67.7vh',
        width: '58vw',
    },
    shippingLabelName: {
        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold",
        fontSize: "20px",
        color: "#000000",
        maxLines: 2,
        textOverflow: "ellipsis",
    },
    shippingLabelAlamat: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 400,
        marginTop: '7px',
        lineHeight: '1.7px',
        fontSize: "7px",
        color: "#000000",
        letterSpacing: "0.2px",
    },
    shippingLabelNoTlp: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 400,
        marginTop: '7px',
        fontSize: "7px",
        color: "#000000",
        letterSpacing: "0.2px",
    },
    addressLabelQrLong: {
        position: 'absolute',
        left: '67.42vw',
        top: '73.16vh',
        minWidth: '24.45vw',
        minHeight: '24.45vw',
        width: '24.45vw',
        height: '24.45vw',
    },
    addressLabelQr: {
        position: 'absolute',
        left: '8.82vw',
        top: '76.75vh',
        minWidth: '18.45vw',
        minHeight: '18.45vw',
        width: '18.45vw',
        height: '18.45vw',
    },
    addressLabelPenerimaLong: {
        position: 'absolute',
        left: '11.32vw',
        top: '25.85vh',
        width: '80vw',
        maxLines: 1,
        textOverflow: "ellipsis",
    },
    addressLabelPengirimLong: {
        position: 'absolute',
        left: '11.32vw',
        top: '71.7vh',
        width: '80vw',
    },
    shippingLabelNameLong: {
        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold",
        fontSize: "14px",
        color: "#000000",
        maxLines: 2,
        textOverflow: "ellipsis",
    },
    shippingLabelOrderIdCodeCourier: {
        position: 'absolute',
        left: '93.32vw',
        top: '16.7vh',
        transform: 'rotate(90deg)',
        transformOrigin: 'top left',

        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold",
        maxLines: 1,
        textOverflow: "ellipsis",
        
        fontSize: "12px",
        color: '#ffffff',
        letterSpacing: "0.5px",
        padding: '5px 7px 2px',
        borderRadius: '10vw',
        backgroundColor: '#000000',
    },
    shippingLabelOrderIdCodeCourierSub: {
        position: 'absolute',
        left: '92.32vw',
        top: '37.7vh',
        transform: 'rotate(90deg)',
        transformOrigin: 'top left',

        fontFamily: 'OakesGrotesk',
        fontWeight: "normal",
        maxLines: 1,
        textOverflow: "ellipsis",
        
        fontSize: "8px",
        letterSpacing: "0.5px",
        padding: '5px 7px 2px',
    },
    shippingLabelOrderIdCode: {
        position: 'absolute',
        right: '8.32vw',
        top: '17.7vh',

        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold",
        maxLines: 1,
        textOverflow: "ellipsis",
        
        fontSize: "12px",
        color: '#ffffff',
        letterSpacing: "0.5px",
        padding: '5px 7px 2px',
        borderRadius: '10vw',
        backgroundColor: '#000000',
    },
    shippingLabelAlamatLong: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 400,
        marginTop: '7px',
        lineHeight: '1.4px',
        fontSize: "7px",
        color: "#000000",
        letterSpacing: "0.2px",
    },
    shippingLabelAlamatPengirimLong: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 400,
        marginTop: '7px',
        lineHeight: '1.4px',
        fontSize: "7px",
        color: "#000000",
        letterSpacing: "0.2px",
        width: '53vw',
    },
    shippingLabelNoTlpLong: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 400,
        marginTop: '7px',
        fontSize: "7px",
        color: "#000000",
        letterSpacing: "0.2px",
    },
    product1Photo: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        left: '80.04vw',
        top: '13.85vh',
        minWidth: '14.45vw',
        width: '14.45vw',
    },
    product2Photo: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        left: '80.04vw',
        top: '0.85vh',
        minWidth: '14.45vw',
        width: '14.45vw',
    },
    productWorkFormPhoto: {
        position: 'absolute',
        left: '0.9vw',
        top: '11.4vh',
        minWidth: '11.6vw',
        width: '11.6vw',
    },
    qrCode: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        left: '80.04vw',
        top: '4.85vh',
        minWidth: '14.45vw',
        minHeight: '14.45vw',
        width: '14.45vw',
        height: '14.45vw',
    },
    qrCodeWorkInputForm: {
        position: 'absolute',
        left: '81.58vw',
        top: '3.25vh',
        minWidth: '10.25vw',
        minHeight: '10.25vw',
        width: '10.25vw',
        height: '10.25vw',
    },
    qrCodeWorkInputFormProduct: {
        position: 'absolute',
        left: '38.28vw',
        top: '12.7vh',
        minWidth: '9.4vw',
        minHeight: '9.4vw',
        width: '9.4vw',
        height: '9.4vw',
    },
    qrCodeRepurchase: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        left: '24.84vw',
        top: '4.85vh',
        minWidth: '13.45vw',
        minHeight: '13.45vw',
        width: '13.45vw',
        height: '13.45vw',
    },
    viewRepurchase: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        top: '23.4vh',
        left: '13.20vw',
        width: '25vw',
    },
    textRepurchase: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 600,
        marginTop: '2px',
        fontSize: 8,
        letterSpacing: 0.1,
        color: "#232323",
        maxLines: 1,
        // textDecoration: 'underline 2px solid black',
        // textUnderlineOffset: 4,
        // textDecorationStyle: '2px solid black',
    },
    qrCodeReferral: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        left: '4.74vw',
        top: '4.85vh',
        minWidth: '13.45vw',
        minHeight: '13.45vw',
        width: '13.45vw',
        height: '13.45vw',
    },
    viewReferral: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        top: '23.4vh',
        left: '-6.86vw',
        width: '25vw',
    },
    textReferral: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 600,
        marginTop: '2px',
        fontSize: 8,
        letterSpacing: 0.1,
        color: "#232323",
        maxLines: 1,
        // textDecoration: 'underline 2px solid black',
        // textUnderlineOffset: 4,
        // textDecorationStyle: '2px solid black',
    },
    viewMeasurementKit: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        top: '19.9vh',
        left: '82.32vw',
        width: '14vw',
    },
    viewKeteranganMeasurementKitThreeLines: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        top: '20.57vh',
        left: '75.32vw',
        width: '14vw',
    },
    namaMeasurementKit: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 'medium',
        marginTop: '2px',
        fontSize: 17.4,
        color: "#232323",
        maxLines: 1,
        textOverflow: "ellipsis",
    },
    subtextTanggalMeasurementKit: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 'light',
        marginTop: '4.2px',
        fontSize: 7.4,
        color: "#848484",
    },
    subtextKeteranganMeasurementKit: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 'light',
        fontSize: 5.8,
        color: "#848484",
        lineHeight: '1.3px',
    },
    itemLabelShrink1: {
        position: 'absolute',
        left: '42.12vw',
        top: '36.3vh',
        width: '20.3vw',
    },
    itemLabelShrink2: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        left: '65.5vw',
        top: '7.0vh',
        width: '20.3vw',
    },
    itemLabelShrinkBlankCover: {
        position: "absolute",
        width: '45vw',
        height: '103px',
        backgroundColor: '#ffffff',
    },
    itemLabel1: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        left: '-5.0vw',
        top: '13.0vh',
        minHeight: '5.1vw',
        height: '5.1vw',
        maxHeight: '5.1vw',
        width: '30vw',
    },
    itemLabel2: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        left: '15.2vw',
        top: '13.0vh',
        minHeight: '5.1vw',
        height: '5.1vw',
        maxHeight: '5.1vw',
        width: '30vw',
    },
    itemLabelProductName: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 'medium',
        fontSize: 12,
        lineHeight: "1.32px",
        minHeight: "8vw",
        height: "8vw",
        maxHeight: "8vw",
        color: "#ffffff",
        width: '22vw',
        maxLines: 2,
        textOverflow: "ellipsis",
    },
    itemLabelMeasurementName: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 600,
        fontSize: 6.3,
        color: "#ffffff",
        position: "absolute",
        top: "38px",
        width: "17vw",
        maxLines: 1,
        textOverflow: "ellipsis",
    },
    itemLabelCustomerNameDiv: {
        position: "absolute",
        top: "37px",
        width: "33.6vw",
        textAlign: "right",
    },
    itemLabelCustomerName: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 600,
        fontSize: 7.3,
        color: "#ffffff",
        maxLines: 1,
        textOverflow: "ellipsis",
    },
    itemLabelBlankCover: {
        position: "absolute",
        top: "-50px",
        left: "-20px",
        width: '242px',
        height: '118px',
        backgroundColor: '#ffffff',
    },
    itemFixLabel1: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        left: '24.6vw',
        top: '39.9vh',
        width: '20.25vw',
    },
    itemFixLabel2: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        left: '77.1vw',
        top: '39.9vh',
        width: '20.25vw',
    },
    itemFixLabelQrContainer: {
        position: 'absolute',
        left: '0px',
        top: '0.5px',
        minWidth: '20.25vw',
        minHeight: '20.25vw',
        width: '20.25vw',
        height: '20.25vw',
        backgroundColor: '#1b1b1b',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    itemFixLabelQr: {
        position: 'absolute',
        left: '0px',
        top: '0px',
        minWidth: '20.25vw',
        minHeight: '20.25vw',
        width: '20.25vw',
        height: '20.25vw',
    },
    itemFixLabelQrRounded: {
        minWidth: '100%',
        minHeight: '100%',
        width: '100%',
        height: '100%',
        padding: '3px 3px 3px 3px',
        backgroundColor: '#f2f2f2',
        borderRadius: "5px"
    },
    itemFixLabelProductNameDiv: {
        position: "absolute",
        top: "131.1px",
        textAlign: 'right',
        width: '20.25vw',
        display: 'flex',
        alignItems: 'flex-end',
    },
    itemFixLabelProductNameDiv2: {
        width: '10vw',
    },
    itemFixLabelProductName: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 600,
        fontSize: 6.5,
        color: "#ffffff",
        maxLines: 1,
        textOverflow: "ellipsis",
    },
    itemFixLabelSizeTypeDiv: {
        position: "absolute",
        top: "147.4px",
        textAlign: 'right',
        width: '20.25vw',
        display: 'flex',
        alignItems: 'flex-end',
    },
    itemFixLabelSizeTypeDiv2: {
        width: '13vw',
    },
    itemFixLabelSizeType: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 600,
        fontSize: 6.5,
        color: "#ffffff",
        maxLines: 1,
        textOverflow: "ellipsis",
    },
    itemFixLabelSizeNameDiv: {
        position: "absolute",
        top: "163.7px",
        textAlign: 'right',
        width: '20.25vw',
        display: 'flex',
        alignItems: 'flex-end',
    },
    itemFixLabelSizeNameDiv2: {
        width: '12vw',
    },
    itemFixLabelSizeName: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 600,
        fontSize: 6.5,
        color: "#ffffff",
        maxLines: 1,
        textOverflow: "ellipsis",
    },
    itemFixLabelBlankCover: {
        position: "absolute",
        top: "-75px",
        left: "-22px",
        width: '160px',
        height: '274px',
        backgroundColor: '#ffffff',
    },
    viewKancingList: {
        position: 'absolute',
        left: '67.5vw',
        top: '2.55vh',
    },
    textBenang: {
        position: 'absolute',
        left: '56.7vw',
        top: '2.55vh',
        padding: '0.6vw 1vw 0.4vw 1vw',
        fontSize: "1.0vw",
        letterSpacing: "0.025vw",
        lineHeight: "0.125vw",
        maxLines: 1,
        textOverflow: "ellipsis",
        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold",
        borderRadius: '100vw',
        color: '#ffffff',
    },
    textTargetPengiriman1: {
        position: 'absolute',
        left: '56.0vw',
        top: '2.55vh',
        padding: '0.4vw 1vw 0.5vw 1vw',
        fontSize: "0.7vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.015vw",
        maxLines: 1,
        textOverflow: "ellipsis",
        color: '#121212',
        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold"
    },
    textTargetPengiriman2Inverse: {
        position: 'absolute',
        left: '56.7vw',
        top: '4.75vh',
        padding: '0.6vw 1vw 0.4vw 1vw',
        fontSize: "1.0vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 1,
        textOverflow: "ellipsis",
        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold",
        borderRadius: '100vw',
        color: '#ffffff',
        backgroundColor: 'rgb(3, 85, 15)',
    },
    textTargetPengiriman3: {
        position: 'absolute',
        left: '56.0vw',
        top: '7.75vh',
        padding: '0.4vw 1vw 0.5vw 1vw',
        fontSize: "0.7vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.015vw",
        maxLines: 1,
        textOverflow: "ellipsis",
        color: '#121212',
        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold"
    },
    textTargetPengiriman4: {
        position: 'absolute',
        left: '56.0vw',
        top: '9.25vh',
        padding: '0.4vw 1vw 0.5vw 1vw',
        fontSize: "0.7vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.015vw",
        maxLines: 1,
        textOverflow: "ellipsis",
        color: '#121212',
        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold"
    },
    textTargetPengirimanJahit1: {
        position: 'absolute',
        left: '55.0vw',
        top: '12.25vh',
        padding: '0.4vw 1vw 0.2vw 1vw',
        fontSize: "0.7vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.015vw",
        maxLines: 1,
        textOverflow: "ellipsis",
        color: '#ffffff',
        backgroundColor: '#000000',
        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold"
    },
    textTargetPengirimanJahit2: {
        position: 'absolute',
        left: '55.0vw',
        top: '14.05vh',
        padding: '0.4vw 1vw 0.5vw 1vw',
        fontSize: "0.7vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.01vw",
        maxLines: 1,
        textOverflow: "ellipsis",
        color: '#121212',
        fontFamily: 'OakesGrotesk',
        fontWeight: "normal"
    },
    textTargetPengirimanJahit3: {
        position: 'absolute',
        left: '55.0vw',
        top: '15.35vh',
        padding: '0.4vw 1vw 0.5vw 1vw',
        fontSize: "0.7vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.01vw",
        maxLines: 1,
        textOverflow: "ellipsis",
        color: '#121212',
        fontFamily: 'OakesGrotesk',
        fontWeight: "normal"
    },
    textTargetPengirimanJahit4: {
        position: 'absolute',
        left: '55.0vw',
        top: '16.65vh',
        padding: '0.4vw 1vw 0.5vw 1vw',
        fontSize: "0.7vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.01vw",
        maxLines: 1,
        textOverflow: "ellipsis",
        color: '#121212',
        fontFamily: 'OakesGrotesk',
        fontWeight: "bold"
    },
    textWorkForm1Cover: {
        position: 'absolute',
        left: '57.7vw',
        top: '2.75vh',
        width: '32.5vh',
        height: '4vh',
        backgroundColor: '#ffffff',
    },
    textWorkForm1: {
        position: 'absolute',
        left: '57.7vw',
        top: '4.75vh',
        width: '32.5vh',
        fontSize: "1vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 6,
        textOverflow: "ellipsis",
        fontWeight: 200
    },
    textWorkForm2Cover: {
        position: 'absolute',
        left: '57.7vw',
        top: '8.25vh',
        width: '32.5vh',
        height: '4vh',
        backgroundColor: '#ffffff',
    },
    textWorkForm2: {
        position: 'absolute',
        left: '57.7vw',
        top: '10.25vh',
        width: '32.5vh',
        fontSize: "1vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 6,
        textOverflow: "ellipsis",
        fontWeight: 200
    },
    textWorkForm3Cover: {
        position: 'absolute',
        left: '57.7vw',
        top: '13vh',
        width: '32.5vh',
        height: '4vh',
        backgroundColor: '#ffffff',
    },
    textWorkForm3: {
        position: 'absolute',
        left: '57.7vw',
        top: '16vh',
        width: '32.5vh',
        fontSize: "1vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 6,
        textOverflow: "ellipsis",
        fontWeight: 200
    },
    textWorkFormOrderId: {
        position: 'absolute',
        left: '6.65vw',
        bottom: '1.2vh',
        width: '32.5vh',
        fontSize: "0.8vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 6,
        textOverflow: "ellipsis",
        fontWeight: 200
    },
    textWorkFormOrderIdb: {
        position: 'absolute',
        left: '12.65vw',
        top: '34.9vh',
        width: '32.5vh',
        fontSize: "0.8vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 6,
        textOverflow: "ellipsis",
        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold"
    },
    textWorkFormOrderIdShort: {
        position: 'absolute',
        left: '12.65vw',
        top: '5.8vh',
        fontSize: "1.35vw",
        color: '#ffffff',
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        padding: '0.5vw 1vw',
        borderRadius: '10vw',
        backgroundColor: '#000000',
        maxLines: 1,
        textOverflow: "ellipsis",
        fontWeight: "semibold",
    },
    textWorkFormOrderIdNum: {
        position: 'absolute',
        left: '19.65vw',
        top: '6.5vh',
        fontSize: "0.8vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        color: '#ffffff',
        padding: '0.3vw 0.7vw',
        borderRadius: '10vw',
        backgroundColor: '#000000',
        maxLines: 6,
        textOverflow: "ellipsis",
        fontWeight: 200
    },
    textWorkFormOrderIdPitaUkurContrast: {
        position: 'absolute',
        left: '24.25vw',
        top: '5.1vh',
        fontSize: "1.35vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        color: 'rgb(3, 89, 0)',
        padding: '0.5vw 1vw',
        borderRadius: '10vw',
        backgroundColor: 'rgb(3, 89, 0)',
        maxLines: 6,
        textOverflow: "ellipsis",
        fontWeight: 200,
        border: '0.5vw solid rgb(3, 89, 0)'
    },
    textWorkFormOrderIdPitaUkur: {
        position: 'absolute',
        left: '24.75vw',
        top: '5.8vh',
        fontSize: "1.35vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        color: '#ffffff',
        padding: '0.5vw 1vw',
        borderRadius: '10vw',
        backgroundColor: 'rgb(11, 8, 200)',
        maxLines: 6,
        textOverflow: "ellipsis",
        fontWeight: 200,
    },
    workFormCourierImage1: {
        position: 'absolute',
        left: '40.05vw',
        top: '2.35vh',
        width: '9.5vh',
    },
    textWorkFormProd1: {
        position: 'absolute',
        left: '13.65vw',
        top: '14.23vh',
        width: '32.5vh',
        fontSize: "0.8vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 6,
        textOverflow: "ellipsis",
        fontWeight: 200
    },
    textWorkFormProd2: {
        position: 'absolute',
        left: '13.65vw',
        top: '20vh',
        width: '32.5vh',
        fontSize: "0.8vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 6,
        textOverflow: "ellipsis",
        fontWeight: 200
    },
    textWorkFormProd3: {
        position: 'absolute',
        left: '13.65vw',
        top: '25.6vh',
        width: '32.5vh',
        fontSize: "0.8vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 6,
        textOverflow: "ellipsis",
        fontWeight: 200
    },
    textWorkFormProd4: {
        position: 'absolute',
        left: '13.65vw',
        top: '31.35vh',
        width: '32.5vh',
        fontSize: "0.8vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 6,
        textOverflow: "ellipsis",
        fontWeight: 200
    },
    textWorkFormProd5: {
        position: 'absolute',
        left: '38.39vw',
        top: '8.58vh',
        padding: '0.6vw 1vw 0.4vw 1vw',
        fontSize: "1.0vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 6,
        textOverflow: "ellipsis",
        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold",
        borderRadius: '100vw',
        color: '#ffffff',
        backgroundColor: 'rgb(37, 37, 37)',
    },
    textWorkFormProdCutScheduleShift1: {
        position: 'absolute',
        left: '33.39vw',
        top: '12.38vh',
        padding: '0.6vw 1vw 0.4vw 1vw',
        fontSize: "1.0vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 6,
        textOverflow: "ellipsis",
        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold",
        borderRadius: '100vw',
        color: '#ffffff',
        backgroundColor: 'rgb(3, 85, 15)',
    },
    textWorkFormProdCutScheduleShift2: {
        position: 'absolute',
        left: '33.39vw',
        top: '12.38vh',
        padding: '0.6vw 1vw 0.4vw 1vw',
        fontSize: "1.0vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 6,
        textOverflow: "ellipsis",
        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold",
        borderRadius: '100vw',
        color: '#ffffff',
        backgroundColor: 'rgb(47, 3, 85)'
    },
    textWorkFormProdLabelNama: {
        position: 'absolute',
        left: '1.39vw',
        top: '40.68vh',
        width: '32.5vh',
        fontSize: "1.2vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 6,
        textOverflow: "ellipsis",
        fontWeight: 600
    },
    textWorkFormProdSpecialNotesRed: {
        position: 'absolute',
        left: '19.19vw',
        top: '39.18vh',
        width: '14vw',
        fontSize: "0.8vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 5,
        textOverflow: "ellipsis",
        fontWeight: 400,
        backgroundColor: 'rgb(151, 19, 19)',
        padding: '0.1vw 0.5vw',
        borderRadius: '0.4vw',
        color: '#fff',
    },
    textWorkFormProdSpecialNotes: {
        position: 'absolute',
        left: '19.19vw',
        top: '39.18vh',
        width: '15vw',
        fontSize: "0.8vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 5,
        textOverflow: "ellipsis",
        fontWeight: 400
    },
    textWorkFormProdSpecialNotes2Red: {
        position: 'absolute',
        left: '16.39vw',
        top: '90.08vh',
        width: '30vw',
        fontSize: "0.8vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 4,
        textOverflow: "ellipsis",
        fontWeight: 400,
        backgroundColor: 'rgb(151, 19, 19)',
        padding: '0.1vw 0.5vw',
        borderRadius: '0.4vw',
        color: '#fff',
    },
    textWorkFormProdSpecialNotes2: {
        position: 'absolute',
        left: '16.39vw',
        top: '90.08vh',
        width: '30vw',
        fontSize: "0.8vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 4,
        textOverflow: "ellipsis",
        fontWeight: 400
    },
    textWorkFormProdSpecialNotesNoticeRight: {
        position: 'absolute',
        left: '36.19vw',
        transform: 'rotate(270deg)',
        top: '50.08vh',
        fontSize: "1.8vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 4,
        textOverflow: "ellipsis",
        fontWeight: 400,
        backgroundColor: 'rgb(151, 19, 19)',
        padding: '0.1vw 0.5vw',
        borderRadius: '0.4vw',
        color: '#fff',
    },
    textWorkFormProdSpecialNotesNoticeLeft: {
        position: 'absolute',
        left: '20.95vw',
        transform: 'rotate(270deg)',
        top: '69.08vh',
        fontSize: "0.8vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 4,
        textOverflow: "ellipsis",
        fontWeight: 400,
        backgroundColor: 'rgb(151, 19, 19)',
        padding: '0.1vw 0.5vw',
        borderRadius: '0.4vw',
        color: '#fff',
    },
    textWorkFormInspect: {
        position: 'absolute',
        left: '43.06vw',
        top: '48.88vh',
        width: '32.5vh',
        fontSize: "0.8vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 6,
        textOverflow: "ellipsis",
        fontWeight: 600
    },
    textFetchItems1: {
        position: 'absolute',
        left: '38.92vw',
        top: '37.1vh',
        width: '17vh',
        transform: 'rotate(90deg)',
        fontSize: "0.6vw",
        lineHeight: "0.2vw",
        letterSpacing: "0.04vw",
        maxLines: 6,
        textOverflow: "ellipsis",
    },
    textFetchItems2: {
        position: 'absolute',
        left: '46.12vw',
        top: '26.8vh',
        width: '20vh',
        transform: 'rotate(180deg)',
        fontSize: "0.6vw",
        lineHeight: "0.2vw",
        letterSpacing: "0.04vw",
        maxLines: 6,
        textOverflow: "ellipsis",
    },
    stockLabelElement: {
        position: 'absolute',
        left: '10vw',
        top: '15.85vh',
        width: '80vw',
        maxLines: 1,
        textOverflow: "ellipsis",
    },
    stockLabelName: {
        fontFamily: 'OakesGrotesk',
        fontWeight: "semibold",
        fontSize: "12px",
        color: "#000000",
        maxLines: 5,
        textOverflow: "ellipsis",
    },
    courierLabelBarcodeAwb: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        transformOrigin: 'center',
        left: '62px',
        top: '118px',
        width: '210px',
    },
    orderItemLabelBarcodeLeft: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        transformOrigin: 'center',
        left: '40vw',
        top: '22vh',
        width: '130px',
    },
    orderItemLabelBarcodeRight: {
        position: 'absolute',
        transform: 'rotate(270deg)',
        transformOrigin: 'center',
        left: '44.2vw',
        top: '22vh',
        width: '130px',
    },
    courierLabelBarcodeCourierOrderID: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        transformOrigin: 'top left',
        left: '148px',
        top: '18px',
        width: '86px',
    },
    courierImageLogoCover: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        transformOrigin: 'top left',
        left: '224px',
        top: '200px',
        height: '26px',
        width: '100px',
        backgroundColor: '#ffffff',
    },
    courierImageLogo: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        transformOrigin: 'top left',
        left: '218px',
        top: '200px',
        height: '26px',
    },
    courierImageLogoWidth: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        transformOrigin: 'top left',
        left: '216px',
        top: '200px',
        width: '70px',
    },
    courierLabelDiv1: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        transformOrigin: 'top left',
        left: '140.5px',
        top: '230px',
        width: '150px',
    },
    courierLabelDiv2: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        transformOrigin: 'top left',
        left: '140.5px',
        top: '80px',
        width: '150px',
    },
    courierLabelShippingTextLight: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 300,
        marginTop: '2.2px',
        lineHeight: '1.4px',
        fontSize: "5px",
        color: "#000000",
        letterSpacing: "0.2px",
    },
    courierLabelPenerima: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        transformOrigin: 'top left',
        left: '96px',
        top: '19px',
        width: '156px',
    },
    courierLabelPengirim: {
        position: 'absolute',
        transform: 'rotate(90deg)',
        transformOrigin: 'top left',
        left: '96px',
        top: '182px',
        width: '100px',
    },
    courierLabelShippingName: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 600,
        marginTop: '7px',
        lineHeight: '1.4px',
        fontSize: "10px",
        color: "#000000",
        letterSpacing: "0.4px",
    },
    courierLabelShippingAddress: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 300,
        marginTop: '1.4px',
        lineHeight: '1.5px',
        fontSize: "5px",
        color: "#000000",
        letterSpacing: "0.4px",
    },
    courierLabelShippingNoTlp: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 300,
        marginTop: '2px',
        lineHeight: '1.5px',
        fontSize: "5px",
        color: "#000000",
        letterSpacing: "0.4px",
    },
    courierLabelShippingListItemStart: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 600,
        marginTop: '2px',
        lineHeight: '1px',
        fontSize: "5px",
        color: "#000000",
        letterSpacing: "0.4px",
    },
    courierLabelShippingListItem: {
        fontFamily: 'OakesGrotesk',
        fontWeight: 300,
        marginTop: '1.5px',
        lineHeight: '1px',
        fontSize: "4px",
        color: "#000000",
        letterSpacing: "0.4px",
    },
    workFormInputCover0: {
        position: 'absolute',
        left: '50.8vw',
        width: '410px',
        backgroundColor: '#ffffff',
    },
    workFormInputCover1: {
        position: 'absolute',
        left: '72vw',
        width: '232px',
        backgroundColor: '#ffffff',
    },
    workFormInputCover2: {
        position: 'absolute',
        left: '86vw',
        width: '114px',
        backgroundColor: '#ffffff',
    },
    workFormInputCoverMeas0: {
        position: 'absolute',
        left: '22.8vw',
        width: '90px',
        backgroundColor: '#ffffff',
    },
    workFormInputCoverInspect0: {
        position: 'absolute',
        left: '37.8vw',
        width: '100px',
        backgroundColor: '#ffffff',
    },
    workFormInputQcChecklistContainer: {
        position: 'absolute',
        left: '31vw',
        width: '125px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textAlign: 'left',
    },
    workFormInputCoverMeasTextContainer: {
        position: 'absolute',
        left: '1.4vw',
        width: '100px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'left',
    },
    workFormInputCoverMeasTextContainer2: {
        position: 'absolute',
        left: '13.11vw',
        width: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
    workFormInputCoverMeasTextContainerMini1: {
        position: 'absolute',
        left: '22.10vw',
        width: '70px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
    workFormInputCoverMeasTextContainerMini2: {
        position: 'absolute',
        left: '25.6vw',
        width: '28px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
    workFormInputCoverMeasTextContainerMini3: {
        position: 'absolute',
        left: '28.9vw',
        width: '28px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
    workFormProductionDetailText: {
        width: '100%',
        fontSize: "1.0vw",
        letterSpacing: "0.025vw",
        maxLines: 2,
        fontWeight: 'bold',
    },
    workFormInputQcChecklistText: {
        width: '100%',
        fontSize: "0.7vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 2,
        fontWeight: 'bold',
    },
    workFormInputMeasText: {
        width: '100%',
        fontSize: "0.78vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 2,
        textOverflow: "ellipsis",
        fontWeight: 'bold',
    },
    workFormInputMeasTextMini: {
        width: '100%',
        fontSize: "0.63vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.003vw",
        maxLines: 2,
        textOverflow: "ellipsis",
        fontWeight: 'bold',
    },
    workFormInputTextContainer: {
        position: 'absolute',
        width: '110px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'left',
    },
    workFormInputText: {
        width: '100%',
        fontSize: "0.85vw",
        lineHeight: "0.125vw",
        letterSpacing: "0.025vw",
        maxLines: 2,
        textOverflow: "ellipsis",
        fontWeight: 'bold',
    }
})

const qrCodeOptions: any = {
    "width": 300,
    "height": 300,
    "data": "https://www.studios.id/create-personal-size-with-kit",
    "margin": 0,
    "qrOptions": {
        "typeNumber": "10",
        "mode": "Byte",
        "errorCorrectionLevel": "H"
    },
    "backgroundOptions": {
      "color": "#f9f9f9"
    },
  }

//   OLD STYLIZED VERSION 
//   const qrCodeOptionsFix: any = {
//     "width": 600,
//     "height": 600,
//     "data": "https://www.studios.id/create-personal-size-with-kit",
//     "margin": 10,
//     "qrOptions": {
//       "typeNumber": "10",
//       "mode": "Byte",
//       "errorCorrectionLevel": "H"
//     },
//     "imageOptions": {
//       "hideBackgroundDots": true,
//       "imageSize": 0.8,
//       "margin": 12
//     },
//     "dotsOptions": {
//       "type": "dots",
//       "color": "#787878",
//       "gradient": null
//     },
//     "backgroundOptions": {
//       "color": "#f2f2f2"
//     },
//     "image": "data:image/png;base64,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",
//     "dotsOptionsHelper": {
//       "colorType": {
//         "single": true,
//         "gradient": false
//       },
//       "gradient": {
//         "linear": true,
//         "radial": false,
//         "color1": "#6a1a4c",
//         "color2": "#6a1a4c",
//         "rotation": "0"
//       }
//     },
//     "cornersSquareOptions": {
//       "type": "dot",
//       "color": "#232323"
//     },
//     "cornersSquareOptionsHelper": {
//       "colorType": {
//         "single": true,
//         "gradient": false
//       },
//       "gradient": {
//         "linear": true,
//         "radial": false,
//         "color1": "#000000",
//         "color2": "#000000",
//         "rotation": "0"
//       }
//     },
//     "cornersDotOptions": {
//       "type": "square",
//       "color": "#232323"
//     },
//     "cornersDotOptionsHelper": {
//       "colorType": {
//         "single": true,
//         "gradient": false
//       },
//       "gradient": {
//         "linear": true,
//         "radial": false,
//         "color1": "#000000",
//         "color2": "#000000",
//         "rotation": "0"
//       }
//     },
//     "backgroundOptionsHelper": {
//       "colorType": {
//         "single": true,
//         "gradient": false
//       },
//       "gradient": {
//         "linear": true,
//         "radial": false,
//         "color1": "#ffffff",
//         "color2": "#ffffff",
//         "rotation": "0"
//       }
//     }
//   }

const qrCodeOptionsFix: any = {
    "width": 600,
    "height": 600,
    "data": "https://www.studios.id/create-personal-size-with-kit",
    "margin": 10,
    "qrOptions": {
      "typeNumber": "10",
      "mode": "Byte",
      "errorCorrectionLevel": "H"
    },
    "backgroundOptions": {
      "color": "#f2f2f2"
    },
  }

const qrCodeWorkInputForm: any = {
"width": 300,
"height": 300,
"data": "orderId",
"margin": 0,
"qrOptions": {
    "typeNumber": "5",
    "mode": "Byte",
    "errorCorrectionLevel": "H"
},
"backgroundOptions": {
    "color": "#ffffff"
},
}

const qrCode = new QRCodeStyling(qrCodeOptions);

const LabelItemShrink = (inputData: {
    objectItem: any,
    stylingLabel: any
}) => {
    if (inputData.stylingLabel === undefined) {
        return (null);
    }
    if (inputData.objectItem === undefined) {
        return (
            <View style={inputData.stylingLabel}>
                <View style={styles.itemLabelShrinkBlankCover}></View>
            </View>
        )
    }
    return null;
}

const LabelItem = (inputData: {
    objectItem: any,
    stylingLabel: any
}) => {
    if (inputData.stylingLabel === undefined) {
        return (null);
    }
    if (inputData.objectItem === undefined) {
        return (
            <View style={inputData.stylingLabel}>
                <View style={styles.itemLabelBlankCover}></View>
            </View>
        )
    }
    return (
        <View style={inputData.stylingLabel}>
            <Text style={styles.itemLabelProductName}>
                {inputData.objectItem.productName}
            </Text>
            <Text style={styles.itemLabelMeasurementName}>
                {inputData.objectItem.sizeType === "personal" ? 
                ("Personal (Custom) Size: " + 
                (inputData.objectItem.sizeValue?.length > 20 ? 
                    inputData.objectItem.sizeValue?.substr(0, 20) : 
                    inputData.objectItem.sizeValue)) : 
                inputData.objectItem.sizeType === "regular" ? 
                ("Regular Size: " + inputData.objectItem.sizeValue) : "" }
            </Text>
            <View style={styles.itemLabelCustomerNameDiv}>
                <Text style={styles.itemLabelCustomerName}>
                    {inputData.objectItem.userName}
                </Text>
            </View>
        </View>
    )
}

const LabelFixItem = (inputData: {
    objectItem: any,
    stylingLabel: any,
}) => {

    if (inputData?.stylingLabel === undefined || (inputData?.objectItem && inputData?.objectItem?.orderIdFullWithNumber === undefined)) {
        return (null);
    }
    if (inputData.objectItem === undefined) {
        return (
            <View style={inputData.stylingLabel}>
                <View style={styles.itemFixLabelBlankCover}></View>
            </View>
        )
    }

    const qrCodeOptionsCopy = JSON.parse(JSON.stringify(qrCodeOptionsFix));
    qrCodeOptionsCopy["data"] = "https://www.studios.id/make-size-from-other/" + inputData.objectItem.orderIdFullWithNumber;
    if (inputData.objectItem.isMarketplaceOrder) {
        qrCodeOptionsCopy["data"] = "https://www.studios.id/adjust-size-mktplc/" + inputData.objectItem.orderIdFullWithNumber;
    }
    const qrCodeFixLabel = new QRCodeStyling(qrCodeOptionsCopy);

    return (
    <View style={inputData.stylingLabel}>
        <View style={styles.itemFixLabelQrContainer}>
            <Image src={qrCodeFixLabel.toDataUrl()} style={styles.itemFixLabelQrRounded} />
        </View>
        {/* <Image src={qrCodeFixLabel.toDataUrl()} style={styles.itemFixLabelQr} /> */}
        <View style={styles.itemFixLabelProductNameDiv}>
            <View style={styles.itemFixLabelProductNameDiv2}>
                <Text style={styles.itemFixLabelProductName}>
                    {inputData.objectItem.productName}
                </Text>
            </View>
        </View>
        <View style={styles.itemFixLabelSizeTypeDiv}>
            <View style={styles.itemFixLabelSizeTypeDiv2}>
                <Text style={styles.itemFixLabelSizeType}>
                    {inputData.objectItem.sizeType === "personal" ? 
                    "Personal (Custom) Size" : 
                    inputData.objectItem.sizeType === "regular" ? 
                    "Regular Size" : "" }
                </Text>
            </View>
        </View>
        <View style={styles.itemFixLabelSizeNameDiv}>
            <View style={styles.itemFixLabelSizeNameDiv2}>
                <Text style={styles.itemFixLabelSizeName}>
                    {inputData.objectItem.sizeValue}
                </Text>
            </View>
        </View>
    </View>
    )
}

export const OrderShippingLabelPages = ({inputData, isLong}) => {
    console.log(JSON.stringify(inputData, null, 2));

    var orderSource: "WEBSITE" | "TOKOPEDIA" | "SHOPEE" = "WEBSITE";

    // DETERMINE CUSTOMER NAME
    var customerName = "Customer";
    if (orderSource === "WEBSITE" && inputData?.userPersonalInputData?.name) {
        customerName = (inputData.userPersonalInputData.name as string);
        const words = customerName.split(" ");

        for (let i = 0; i < words.length; i++) {
            if (words[i].length > 0) {
                words[i] = words[i][0].toUpperCase() + words[i].substring(1);
            }
        }

        customerName = words.join(" ");
    }
    // TODO ADD FOR SHOPEE AND TOKOPEDIA ORDERS

    // ORDER ADDRESS
    var orderAddress: any = {
        orderId: "2023-06-05T11:36:32.716Z-kode-order-tujuan-disini",
        addressName: "Alamat Tujuan",
        address: "Alamat pengiriman barang customer",
        kotaKecamatanText: "Kota Tujuan, Kecamatan Tujuan, Provinsi Tujuan",
        kodePos: 11111,
        phoneNumber: "0878123456789",
        shipmentLabelUrl: "",
        orderIdFull: "2023-06-04T10:08:33.436Z-5368bdb0-f37f-40ec-ba4f-b",
    }

    var variableName: string;

    if (orderSource === "WEBSITE") {
        variableName = "orderId";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "addressName";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "address";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "kotaKecamatanText";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "kodePos";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "keterangan";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "phoneNumber";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "orderIdFull";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        } else if (inputData?.orderData?.userSub && inputData?.orderData?.creationDateTime) {
            orderAddress[variableName] = inputData.orderData.creationDateTime + "-" + inputData.orderData.userSub;
        }
    }
    // TODO ADD FOR SHOPEE AND TOKOPEDIA ORDERS

    // THERE ARE 2 POSSIBILITIES: PERSONAL AND REGULAR SIZE.
    var measKitVariables: any = {
        createPersonalSizeUrl: 'https://www.studios.id/shop', // URL for random users
        name: customerName === "Customer" ? "USER" : customerName, // Placeholder / default value
        sizeType: "personal",

        // Personal Variables
        height: 180, // Placeholder / default value
        weight: 70, // Placeholder / default value

        // Regular Variables
        regularSize: "Small (S)", // Placeholder / default value
    }
    if (orderSource === "WEBSITE") {
        const userSub = inputData?.orderData?.userSub;

        if (userSub.startsWith("tokopedia-") || userSub.startsWith("shopee-")) { // TODO SHOPEE AND TOKPED SUPPORT REMAINING
            return null;
        }

        measKitVariables.createPersonalSizeUrl = "https://www.studios.id/create-personal-size-with-kit/" + userSub;
        qrCode.update({data: measKitVariables.createPersonalSizeUrl});

        variableName = "name";
        if (inputData?.userPersonalInputData?.[variableName]) {
            measKitVariables[variableName] = inputData.userPersonalInputData[variableName];
        }
        variableName = "sizeType";
        if (inputData?.userPersonalInputData?.[variableName]) {
            measKitVariables[variableName] = inputData.userPersonalInputData[variableName];
        }
        variableName = "height";
        if (inputData?.userPersonalInputData?.[variableName]) {
            measKitVariables[variableName] = inputData.userPersonalInputData[variableName];
        }
        variableName = "weight";
        if (inputData?.userPersonalInputData?.[variableName]) {
            measKitVariables[variableName] = inputData.userPersonalInputData[variableName];
        }
        variableName = "regularSize";
        if (inputData?.userPersonalInputData?.[variableName]) {
            measKitVariables[variableName] = inputData.userPersonalInputData[variableName];
        }
    }
    // TODO FOR SHOPEE AND TOKOPEDIA ORDERS

    const pages = [];

    qrCode.update({data: 'o-' + inputData?.orderData?.orderId});
    const orderUrl = qrCode.toDataUrl();

    pages.push(
    <Page key={"page0"} size={[232, 292]}>
        <Image src="https://images-far-east.s3.ap-southeast-1.amazonaws.com/ShippingLabelStudioS.png" style={styles.pageBackgroundShipping}/>
        <View>
            <Image src={orderUrl} style={isLong ? styles.addressLabelQrLong : styles.addressLabelQr} />
        </View>
        <Text style={styles.shippingLabelOrderIdCode}>
            {inputData?.orderData?.orderId?.substring(30)?.toUpperCase()}
        </Text>
        <View style={isLong ? styles.addressLabelPenerimaLong : styles.addressLabelPenerima}>
            <Text style={isLong ? styles.shippingLabelNameLong : styles.shippingLabelName}>{/*customerName*/}</Text>
            <Text style={isLong ? styles.shippingLabelAlamatLong : styles.shippingLabelAlamat}>{/*orderAddress.address + ", " + orderAddress.kotaKecamatanText + " " + orderAddress.kodePos 
            + " " + (orderAddress?.keterangan ? ("Keterangan: " + orderAddress.keterangan) : "")*/}</Text>
            <Text style={isLong ? styles.shippingLabelNoTlpLong : styles.shippingLabelNoTlp}>No. Tlp. 
                {orderAddress.phoneNumber.substr(0, 4)
                + '-' + orderAddress.phoneNumber.substr(4, 4)
                + (orderAddress.phoneNumber.length > 8 ? ('-' + orderAddress.phoneNumber.substr(8)) : "")} / 
                {inputData?.orderData?.phoneNumber.substr(0, 4)
                + '-' + inputData?.orderData?.phoneNumber.substr(4, 4)
                + (inputData?.orderData?.phoneNumber.length > 8 ? ('-' + inputData?.orderData?.phoneNumber.substr(8)) : "")}</Text>
        </View>
        <View style={isLong ? styles.addressLabelPengirimLong : styles.addressLabelPengirim}>
            <Text style={isLong ? styles.shippingLabelNameLong : styles.shippingLabelName}>Studio S.</Text>
            <Text style={isLong ? styles.shippingLabelAlamatPengirimLong : styles.shippingLabelAlamat}>Jl. Alamanda X Blok I 10 No. 16, Jelupang, Serpong Utara, Tangerang Selatan, Banten 15323</Text>
            <Text style={isLong ? styles.shippingLabelNoTlpLong : styles.shippingLabelNoTlp}>No. Tlp. 0878-1302-8340</Text>
        </View>
    </Page>);

    return pages;
}

export const OrderShippingLabel = ({inputData, isLong}) => {

    return (
    <Document>
        {OrderShippingLabelPages({inputData: inputData, isLong: isLong})}
    </Document>);
}

const courierImagesDict = {
    "sicepat":  "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/logistik-sicepat.png",
    "jne":      "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/logistik-jne.png",
    "jnt":      "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/logistik-jnt-express.png",
    "sap":      "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/logistik-sap-express.png",
    "lion":     "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/logistik-lion.png",
    "idx":      "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/logistik-id-express.png",
    "spx":      "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/logistik-spx.png",
    "anteraja": "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/logistik-anteraja.png",
    "sentral":  "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/logistik-sentral-kargo.jpeg",
    "ncs":      "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/logistik-ncs.png",
    "ninja":    "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/logistik-ninja.png",
    "tiki":     "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/logistik-tiki.png",
    "jtcargo":  "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/logistik-jnt.png",
}

export const OrderCourierLabel = ({inputData}) => {

    return (
    <Document>
        {OrderCourierLabelPages({inputData: inputData})}
    </Document>);
}
export const OrderCourierLabelPages = ({inputData}) => {

    var orderSource: "WEBSITE" | "TOKOPEDIA" | "SHOPEE" = "WEBSITE";

    // DETERMINE CUSTOMER NAME
    var customerName = "Customer";
    if (inputData?.orderData?.orderName) {
        customerName = inputData.orderData.orderName;
    }

    // ORDER ADDRESS
    var orderAddress: any = {
        orderId: "2023-06-05T11:36:32.716Z-kode-order-tujuan-disini",
        addressName: "Alamat Tujuan",
        address: "Alamat pengiriman barang customer",
        kotaKecamatanText: "Kota Tujuan, Kecamatan Tujuan, Provinsi Tujuan",
        kodePos: 11111,
        phoneNumber: "0878123456789",
        shipmentLabelUrl: "",
        orderIdFull: "2023-06-04T10:08:33.436Z-5368bdb0-f37f-40ec-ba4f-b",
    }

    var variableName: string;

    if (orderSource === "WEBSITE") {
        variableName = "orderId";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "addressName";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "address";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "kotaKecamatanText";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "kodePos";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "keterangan";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "phoneNumber";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "orderIdFull";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        } else if (inputData?.orderData?.userSub && inputData?.orderData?.creationDateTime) {
            orderAddress[variableName] = inputData.orderData.creationDateTime + "-" + inputData.orderData.userSub;
        }
    }

    const pages = [];

    let courierAwb = inputData?.orderData?.courierAwb ? inputData.orderData.courierAwb : "12345678901";

    let canvas1 = document.createElement('canvas');
    JsBarcode(canvas1, courierAwb, {
        width: 5,
        height: courierAwb.length <= 11 ? 60 : courierAwb.length <= 15 ? 70 : courierAwb.length <= 19 ? 77 : 
        courierAwb.length <= 23 ? 91 : 
        courierAwb.length <= 27 ? 91 : 
        courierAwb.length <= 30 ? 100 : 110,
        fontSize: 24
    });
    const barcode1 = canvas1.toDataURL();

    let canvas2 = document.createElement('canvas');
    JsBarcode(canvas2, inputData?.orderData?.courierOrderId ? inputData.orderData.courierOrderId : "SDS-1701111111111", {
        width: 4,
        height: 90,
        fontSize: 22
    });
    const barcode2 = canvas2.toDataURL();

    const orderItemStrings: string[] = [];
    if (inputData?.orderData?.cartProductList?.length && inputData?.orderData?.cartProductList?.length > 0) {
        let counter = 0;
        for (let indexCartItem = 0; indexCartItem < inputData.orderData.cartProductList.length; indexCartItem = indexCartItem + 1) {
            for (let j = 0; j < inputData.orderData.cartProductList[indexCartItem].amount; j++) {
                var cartProductItem = inputData?.orderData?.cartProductList?.[indexCartItem];

                let productAndSizeString = inputData.orderData.cartProductList?.[indexCartItem]?.productDetail?.name ?? 'Product';
                productAndSizeString = productAndSizeString + ": ";
                
                var labelForItem = {
                    productId: cartProductItem?.productDetail?.productId,
                    productName: cartProductItem?.productDetail?.name,
                    displayImage: cartProductItem?.productDetail?.displayImage,
                    sizeType: cartProductItem?.sizeType,
                    sizeValue: "CUSTOMER SIZE",
                    userName: customerName,
                }

                if (labelForItem.sizeType === "regular"
                && cartProductItem?.regularSize
                && cartProductItem?.regularSize !== "NOTSELECTED") {
                    productAndSizeString += cartProductItem.regularSize + ', ';
                }

                if (labelForItem.sizeType === "personal"
                && cartProductItem?.userMeasurementsForItem?.measurementName) {
                    productAndSizeString += cartProductItem.userMeasurementsForItem.measurementName + ', ';
                }

                orderItemStrings.push(productAndSizeString);
            }
        }
    }

    const courierImage = courierImagesDict?.[inputData?.orderData?.courierSelectionObject?.service] ? courierImagesDict[inputData.orderData.courierSelectionObject.service] : "";

    pages.push(
    <Page key={"page0"} size={[232, 292]}>
        <Image src="https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/CourierLabelStudioS.png" style={styles.pageBackgroundShipping}/>
        <View style={styles.courierLabelPenerima}>
            <Text style={styles.courierLabelShippingName}>{customerName.toUpperCase()}</Text>
            <Text style={styles.courierLabelShippingAddress}>{orderAddress.address + ", " + orderAddress.kotaKecamatanText + " " + orderAddress.kodePos 
            + " " + (orderAddress?.keterangan ? ("Keterangan: " + orderAddress.keterangan) : "")}</Text>
            <Text style={styles.courierLabelShippingNoTlp}>No. Tlp. {orderAddress.phoneNumber.substr(0, 4)
            + '-' + orderAddress.phoneNumber.substr(4, 4)
            + (orderAddress.phoneNumber.length > 8 ? ('-' + orderAddress.phoneNumber.substr(8)) : "")}</Text>
        </View>
        <Text style={styles.shippingLabelOrderIdCodeCourier}>
            {inputData?.orderData?.orderId?.substring(30)?.toUpperCase()}
        </Text>
        {/* <Text style={styles.shippingLabelOrderIdCodeCourierSub}>
            {inputData?.orderData?.itemsCutQueueStatus?.length ?? 0} ITEM(S)
        </Text> */}
        <View style={styles.courierLabelPengirim}>
            <Text style={styles.courierLabelShippingName}>STUDIO S.</Text>
            {/* <Text style={styles.courierLabelShippingAddress}>Jl. Alamanda X Blok I 10 No. 16, Jelupang, Serpong Utara, Tangerang Selatan, Banten 15323</Text> */}
            <Text style={styles.courierLabelShippingNoTlp}>No. Tlp. 0878-1302-8340</Text>
            <Text style={styles.courierLabelShippingListItemStart} key={'item-0'}>{inputData?.orderData?.itemsCutQueueStatus?.length ?? 0} PCS BAJU {inputData?.orderData?.paidOrderCount === 1 ? '+ 1 KARTU UKURAN' : ''}</Text>
            {
                orderItemStrings.map((objItem: string, index: number) => (index < 5 ? <Text style={styles.courierLabelShippingListItem} key={'item-' + index}>{objItem}</Text> : null))
            }
            {
                orderItemStrings?.length > 5 ? 
                <Text style={styles.courierLabelShippingListItem} key={'item-last'}>dan {orderItemStrings?.length - 5} pcs baju lainnya.</Text>:
                null
            }
        </View>
        <View style={styles.courierLabelDiv1}>
            <Text style={styles.courierLabelShippingTextLight}>{"Rp -"}{/*"Rp " + inputData?.orderData?.shipmentPrice?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")*/}</Text>
            <Text style={styles.courierLabelShippingTextLight}>{inputData?.orderData?.courierWeight + " gram"}</Text>
            <Text style={styles.courierLabelShippingTextLight}>{"Baju"}</Text>
        </View>
        <View style={styles.courierLabelDiv2}>
            <Text style={styles.courierLabelShippingTextLight}>{inputData?.orderData?.courierSelectionObject?.service?.toUpperCase()}</Text>
            <Text style={styles.courierLabelShippingTextLight}>{inputData?.orderData?.courierSelectionObject?.service_name}</Text>
            <Text style={styles.courierLabelShippingTextLight}>{"NON COD (Tidak Perlu Bayar)"}</Text>
        </View>
        <Image src={barcode1} style={styles.courierLabelBarcodeAwb}/>
        {/* <Image src={barcode2} style={styles.courierLabelBarcodeCourierOrderID}/> */}
        {
            courierImage ? 
            <>
                <View style={styles.courierImageLogoCover}/>
                {
                    inputData?.orderData?.courierSelectionObject?.service === "jnt" ||
                    inputData?.orderData?.courierSelectionObject?.service === "jtcargo" ||
                    inputData?.orderData?.courierSelectionObject?.service === "sicepat" ? 
                    <Image src={courierImage} style={styles.courierImageLogoWidth}/>:
                    <Image src={courierImage} style={styles.courierImageLogo}/>
                }
            </>:
            null
        }
    </Page>);

    return pages;
}

export const StockLabel = ({inputData}) => {

    const pages = [];

    pages.push(
    <Page key={"page0"} size={[232, 292]}>
        <Image src="https://images-far-east.s3.ap-southeast-1.amazonaws.com/StockLabelStudioS.png" style={styles.pageBackgroundShipping}/>
        <View style={styles.stockLabelElement}>
            <Text style={styles.stockLabelName}>{inputData?.name ? inputData.name : "NAMA BAHAN"}</Text>
        </View>
    </Page>);

    return (
    <Document>
        {pages}
    </Document>);
}


// VERSION JULY 20, 2024
function getConcatNamePreserveFrontBack(inputName: string) {
    const firstLetter = inputName[0];
    const lastLetter = inputName[inputName.length - 1];
  
    const wordWithoutFirstLast = inputName.substring(1, inputName.length - 1);
  
    let wordWithoutFirstLastConcat = wordWithoutFirstLast.replace(/[aeiouAEIOU]/g, '');
    let completeWordWithoutFirstLastConcat = firstLetter + wordWithoutFirstLastConcat + lastLetter;
  
    return completeWordWithoutFirstLastConcat;
}
  
// VERSION JULY 20, 2024
export function getLabelName(currentName: string) {
    // ORDER OF PRIORITIES - July 20, 2024
    // 1. First-met name, more than 2 characters long, unedited
    // 2. Initials, given there's 2 or more words
    // 3. Second-met name, third-met name, and so forth
    // 4. First-met name, more than 2 characters long, concatenated
    // 5. First-met name, more than 2 characters long, 3 first characters
  
    // NEXT IMPROVEMENTS
    // 1. Concat to max letters, try to remove as few vowels as possible
  
    const capsName = currentName.toUpperCase().replace(/[^a-zA-Z ]+/g, '');;
    const capsNameList = capsName.split(" ");
  
    let labelName = "";
  
    let initials = "";
    let validConcatName = "";
    let validConcatNameSuper = "";
  
    let startingIndex = -1;
  
    const maxLetters = 7;
  
    for (let capNameIndex = 0; capNameIndex < capsNameList.length; capNameIndex = capNameIndex + 1) {
  
      if (capsNameList?.[capNameIndex].length > 1) {
        initials = initials + capsNameList?.[capNameIndex][0];
      }
  
      if (capsNameList?.[capNameIndex].length > 2) {
  
        if (startingIndex === -1) {
          startingIndex = capNameIndex;
        }
        let labelNameWithoutI = capsNameList?.[capNameIndex].replace(/I/g, '');
        let concatName = getConcatNamePreserveFrontBack(capsNameList[capNameIndex]);
        let concatNameWithoutI = concatName.replace(/I/g, '');
  
        // Consider first name, max 6 huruf kecuali I
        if ((capsNameList[capNameIndex].length <= maxLetters || labelNameWithoutI?.length <= maxLetters) && labelName === "") {
          labelName = capsNameList[capNameIndex];
        }
        // Get concatenated version (only the first one)
        else if ((concatName?.length <= maxLetters || concatNameWithoutI?.length <= maxLetters) && validConcatName === "") {
          validConcatName = concatName;
        } else if (validConcatName === "") {
          validConcatNameSuper = capsNameList[capNameIndex].substring(0, 3);
        }
      }
    }
  
    if (startingIndex !== -1 && labelName !== capsNameList[startingIndex] && initials.length > 1) {
      labelName = initials.substring(0, maxLetters);
    }
    if (labelName === "" && validConcatName.length > 1) {
      labelName = validConcatName;
    }
    if (labelName === "" && validConcatNameSuper.length > 1) {
      labelName = validConcatNameSuper;
    }
  
    if (capsName === "MARKETPLACE") {
      labelName = "SDS"
    }
  
    return labelName;
}

function getCurrentTimeString(): string {
    const now = new Date();
  
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
  
    const month = months[now.getMonth()];
    const day = now.getDate();
    const year = now.getFullYear();
    const   
   hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
  
    return `${month} ${day}, ${year} - ${hours}:${minutes} WIB`;
  }

  function padIndex(index: number, length = 3): string {
    const minimumLength = Math.max(length, 3);
    return index.toString().padStart(minimumLength, "0");
  }

export const WorkInputFormPages = ({inputData, midstockList}) => {
    console.log('WORK INPUT FORM PDF: ', JSON.stringify(inputData, null, 2));
    
    const qrCodeOptionsCopy = JSON.parse(JSON.stringify(qrCodeWorkInputForm));

    const giveMeasKit = inputData?.orderData?.paidOrderCount === 1;

    const orderId = inputData.orderData.orderId || ''
    const specialNotes = inputData?.orderData?.orderSpecialRequest?.notes ?? '';
    const addressFirst = inputData?.orderData?.address.substring(0, 40) ?? '-';

    const availableDays = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']; // Minggu di 0 ternyata
    const shipEarlyDayInt = new Date(inputData?.orderData?.expressShipmentDate + "T13:00:00.000Z").getDay() ?? 0;
    const shipEarlyDayString = availableDays?.[shipEarlyDayInt]?.toUpperCase();
    const shipEarlyDate = new Date(inputData?.orderData?.expressShipmentDate).toLocaleDateString('id-ID', { month:"long", day:"numeric"});
    const shipNormalDayString = availableDays?.[new Date(inputData?.orderData?.standardShipmentDate + "T13:00:00.000Z").getDay() ?? 0]?.toUpperCase();

    const coverStyles = {
        1: styles.workFormInputCover1,
        2: styles.workFormInputCover2,
    };

    const courierImage = courierImagesDict?.[inputData?.orderData?.courierSelectionObject?.service] ? courierImagesDict[inputData.orderData.courierSelectionObject.service] : "";

    const allOrderNameString = inputData?.orderData?.orderName ? inputData.orderData.orderName : "CUST";
    const defaultLabelNama = getLabelName(allOrderNameString);

    const orderLabelNamaManualArray = inputData?.orderData?.labelNamaManualArray ?? [];
    const orderItemsOrderCodeArray = inputData?.orderData?.itemsOrderCodeArray ?? [];
    const orderItemsCutQueueSchedule = inputData?.orderData?.itemsCutQueueSchedule ?? [];
    
    const orderLabelNama = inputData?.userPersonalInputData?.labelNama;

    // DETERMINE CUSTOMER NAME
    var customerName = "Customer";
    if (inputData?.userPersonalInputData?.name) {
        customerName = inputData.userPersonalInputData.name;
    }
    if (inputData?.orderData?.paymentStatus === "capture_marketplace") {
        customerName = "Order Marketplace";
    }

    // ITEM LABELS
    const orderItems: any[] = [];
    if (inputData?.orderData?.cartProductList?.length && inputData?.orderData?.cartProductList?.length > 0) {
        let counter = 0;
        for (let indexCartItem = 0; indexCartItem < inputData.orderData.cartProductList.length; indexCartItem = indexCartItem + 1) {
            for (let j = 0; j < inputData.orderData.cartProductList[indexCartItem].amount; j++) {
                var cartProductItem = inputData?.orderData?.cartProductList?.[indexCartItem];

                const cutScheduleCurrent = 
                    orderItemsCutQueueSchedule?.[counter] ? orderItemsCutQueueSchedule[counter] : 'ERROR';
                const labelNamaCurrent = 
                    orderLabelNamaManualArray?.[counter] ? orderLabelNamaManualArray[counter] :
                    cartProductItem?.labelNama ? cartProductItem.labelNama :
                    orderLabelNama ? orderLabelNama :
                    defaultLabelNama;
                const itemOrderCode = orderItemsOrderCodeArray?.[counter];

                // QC is not in product detail processesData, but is in the WorkOrderItemFulfillTable entry.
                const processesData = 
                cutScheduleCurrent === "REGULER" ? 
                [
                    {
                        "processName": "Label Nama",
                        "processPoints": 1.5,
                        "timeSpent": 16,
                        "maxPeople": 1,
                        "scheduleStage": "PENGIRIMAN",
                    },
                    {
                        "processName": "QC & Pack Uk Jadi",
                        "processPoints": 3.8,
                        "timeSpent": 16,
                        "maxPeople": 1,
                        "scheduleStage": "QC",
                    }
                ]:
                inputData.orderData.cartProductList?.[indexCartItem]?.productDetail?.processesData ? 
                inputData.orderData.cartProductList[indexCartItem].productDetail.processesData :
                [
                    {
                        "processName": "POTONGLASER",
                        "processPoints": 3.3,
                        "timeSpent": 10,
                        "maxPeople": 1
                    },
                    {
                        "processName": "JAHITOBRAS",
                        "processPoints": 3.3,
                        "timeSpent": 10,
                        "maxPeople": 1
                    },
                    {
                        "processName": "JAHITLURUS",
                        "processPoints": 3,
                        "timeSpent": 15,
                        "maxPeople": 1
                    },
                    {
                        "processName": "PACKING",
                        "processPoints": 4.3,
                        "timeSpent": 16,
                        "maxPeople": 1
                    }
                ];

                let simpleLocationString: string = '';
                let fetchItemString: string = '';
                if (inputData?.inventoryRequestData?.itemsFetchList?.[counter]) {
                    for (let itemNeeded2 of Object.keys(inputData?.inventoryRequestData?.itemsFetchList?.[counter])) {
                        fetchItemString += (itemNeeded2?.startsWith("midstock") ? "[STOK KERAH] " : "[STOK REGULER] ") + itemNeeded2 + " : " + inputData?.inventoryRequestData?.itemsFetchList?.[counter]?.[itemNeeded2] + ", ";

                        const midstockObj = midstockList?.find((objItem: any) => objItem.midstockId === itemNeeded2);
                        if (midstockObj) {
                            fetchItemString += ("(LOKASI: " + (midstockObj?.physicalLocationArray?.map((physicalLoc: any) => physicalLoc.kodeRak + ": Baris " + physicalLoc.noKeranjang).join(' ATAU ') ?? '-') + " )");
                        }
                        if (midstockObj?.physicalLocationArray?.length) {
                            simpleLocationString = (midstockObj?.physicalLocationArray?.map((physicalLoc: any) => "RAK " + physicalLoc.kodeRak + " | BARIS " + physicalLoc.noKeranjang)?.[0] ?? '');
                        }
                    }
                }
                if (inputData?.orderData?.paymentStatus === "capture_marketplace") {
                    fetchItemString = "[STOK REGULER] " + cartProductItem?.regularSize;
                }
                if (fetchItemString?.length === 0) {
                    fetchItemString = inputData?.itemsCutQueueSchedule?.[counter] === "REGULER" ? "[STOK REGULER] -" : "[STOK KERAH] -" ;
                }
                
                var labelForItem = {
                    productId: cartProductItem?.productDetail?.productId,
                    productName: cartProductItem?.productDetail?.name,
                    displayImage: cartProductItem?.productDetail?.displayImage,
                    sizeType: cartProductItem?.sizeType,
                    sizeValue: "CUSTOMER SIZE",
                    userName: customerName,
                    isMarketplaceOrder: inputData?.orderData?.paymentStatus === "capture_marketplace",
                    orderIdFullWithNumber: inputData?.orderData?.orderIdFull + "-" + String(indexCartItem).padStart(4, '0'),
                    labelNama: labelNamaCurrent,
                    clothingMeasurementsForItem: getClothingMeasurementsForItem(cartProductItem),
                    simpleLocationString: simpleLocationString,
                    fetchItemString: fetchItemString,
                    inspectItem: inputData?.orderData?.inspectList?.[counter] !== undefined ? inputData.orderData.inspectList[counter] : true,
                    cutScheduleCurrent: cutScheduleCurrent,
                    qcChecklistArray: [
                        "Baju LAYAK KIRIM (tidak luntur, bolong, pudar, dengan kancing lengkap & baik)",
                        "Label nama SUDAH sesuai: " + labelNamaCurrent,
                        ...(inputData?.itemsCutQueueSchedule?.[counter] === "REGULER" ? ["Bener ya udah sesuai. Dari stok reguler! Label nama: " + labelNamaCurrent] : []),
                        ...getQcChecklistForClothingType(cartProductItem?.productDetail?.clothingType), // Category based QC Checklist
                        ...(cartProductItem?.productDetail?.additionalQcChecklistArray ?? []), // Product based QC Checklist
                    ],
                    productionDetailThreadArray: cartProductItem?.productDetail?.productionDetailThreadArray ?? [], //[{ kodeWarna: 'HITAM', hexColor: '#232323' },{ kodeWarna: '111b', hexColor: 'rgb(137, 18, 18)' },{ kodeWarna: '111b', hexColor: '#112200' }],
                    productionDetailButtonArray: cartProductItem?.productDetail?.productionDetailButtonArray ?? [], //[{ kodeKancing: 'PTHBNG', namaKancing: 'Putih Bening', imageUrl: 'https://studiosclo.uk/general/kancing-bening.png' }],
                }

                if (labelForItem.sizeType === "regular"
                && cartProductItem?.regularSize
                && cartProductItem?.regularSize !== "NOTSELECTED") {
                    labelForItem.sizeValue = cartProductItem.regularSize;
                }

                if (labelForItem.sizeType === "personal"
                && cartProductItem?.userMeasurementsForItem?.measurementName) {
                    labelForItem.sizeValue = cartProductItem.userMeasurementsForItem.measurementName;
                    if (cartProductItem?.userMeasurementsForItem?.nama) {
                        labelForItem.userName = cartProductItem.userMeasurementsForItem.nama;
                    }
                }

                orderItems.push({
                    ...labelForItem,
                    orderId: orderId + '+' + padIndex(counter), 
                    productName: cartProductItem.productDetail.name || 'Nama Produk',
                    processesData: processesData,
                    itemOrderCode: itemOrderCode,
                })
                counter++;
            }
        }
    }

    const jsonToPrint: any = {
        orderItems: orderItems,
    }
    console.log('TEST L jsonToPrint: ', jsonToPrint)

    const pages = [];

    for (let i = 0; i < orderItems.length; i++) {

        qrCode.update({data: orderItems[i].orderId });
        const workInputUrl = qrCode.toDataUrl();
        qrCode.update({data: 'https://www.studios.id/shop/product/' + orderItems[i].productId});
        const workInputProductUrl = qrCode.toDataUrl();

        let formFieldCounter = 0;

        // CREATE BARCODE FOR THIS
        let canvas1 = document.createElement('canvas');
        JsBarcode(canvas1, orderItems[i].itemOrderCode + "H8L", {
            width: 5,
            height: 110,
            fontSize: 24,
        });
        const barcodeLeft = canvas1.toDataURL();
        let canvas2 = document.createElement('canvas');
        JsBarcode(canvas2, orderItems[i].itemOrderCode + "H8R" , {
            width: 5,
            height: 110,
            fontSize: 24,
        });
        const barcodeRight = canvas2.toDataURL();
        let canvas3 = document.createElement('canvas');
        JsBarcode(canvas3, orderItems[i].itemOrderCode + "H8X", {
            width: 5,
            height: 110,
            fontSize: 24,
        });
        const barcodeRegular = canvas3.toDataURL();
    
        pages.push(
            <Page size="A4" orientation="landscape" key={`page-${i}`}>
                <Image src="https://studiosclo.uk/general/WorkInputFormV2-Feb-18-2026.png" style={styles.pageBackground}/>

                <Text style={styles.textWorkFormOrderId}>
                    {orderItems[i].orderId.split('+')?.[0]} 
                </Text>
                <Text style={styles.textWorkFormOrderIdShort}>
                    {orderItems[i].orderId.split('+')?.[0]?.substring(30)?.toUpperCase()}
                </Text>
                <Text style={styles.textWorkFormOrderIdb}>
                    [{allOrderNameString}] {addressFirst} 
                </Text>
                <Text style={styles.textWorkFormOrderIdNum}>
                    {Number(orderItems[i].orderId.split('+')?.[1]) + 1} dari {((orderItems?.length) ?? 1)}
                </Text>
                {/* {
                    giveMeasKit ? 
                    <Text style={styles.textWorkFormOrderIdPitaUkurContrast}>KASIH PITA UKUR</Text>:
                    null
                } */}
                {
                    giveMeasKit ? 
                    <Text style={styles.textWorkFormOrderIdPitaUkur}>KASIH PITA UKUR</Text>:
                    null
                }
                {
                    courierImage ?
                    <View>
                        <Image src={courierImage} style={styles.workFormCourierImage1} />
                    </View>:
                    null
                }

                {
                    orderItems[i]?.displayImage ?
                    <Image src={orderItems[i].displayImage?.replace('.jpg', '_360.jpg')?.replace('.png', '_360.png')?.replace('.jpeg', '_360.jpeg')} style={styles.productWorkFormPhoto} />:
                    null
                }
                <Text style={styles.textWorkFormProd1}>
                    {orderItems[i].productName} 
                </Text>
                <Text style={styles.textWorkFormProd2}>      
                    {orderItems[i].sizeType === "personal" ? 
                    "Personal (Custom) Size" : 
                    orderItems[i].sizeType === "regular" ? 
                    "Regular Size" : "" }
                </Text>
                <Text style={styles.textWorkFormProd3}>
                    {orderItems[i].sizeValue} 
                </Text>
                <Text style={styles.textWorkFormProd4}>
                    {orderItems[i].fetchItemString} 
                </Text>
                {
                    orderItems?.[i]?.simpleLocationString ?
                    <Text style={styles.textWorkFormProd5}>
                        {orderItems[i].simpleLocationString}
                    </Text>:
                    null
                }

                {
                    orderItems[i].cutScheduleCurrent === "REGULER" ? 
                    null :
                    orderItems[i].cutScheduleCurrent?.includes("SHIFT1") ? 
                    <Text style={styles.textWorkFormProdCutScheduleShift1}>
                        {orderItems[i].cutScheduleCurrent} 
                    </Text> :
                    orderItems[i].cutScheduleCurrent?.includes("SHIFT2") ? 
                    <Text style={styles.textWorkFormProdCutScheduleShift2}>
                        {orderItems[i].cutScheduleCurrent} 
                    </Text> :
                    null
                }

                {
                    orderItems?.[i]?.itemOrderCode ?
                    <Image src={orderItems[i].cutScheduleCurrent === "REGULER" ? barcodeRegular : barcodeLeft} style={styles.orderItemLabelBarcodeLeft}/>:
                    null
                }
                {
                    orderItems?.[i]?.itemOrderCode ?
                    <Image src={orderItems[i].cutScheduleCurrent === "REGULER" ? barcodeRegular : barcodeRight} style={styles.orderItemLabelBarcodeRight}/>:
                    null
                }

                <Text style={styles.textWorkFormProdLabelNama}>
                    {orderItems[i].labelNama} 
                </Text>
                {
                    specialNotes ? 
                    <Text style={styles.textWorkFormProdSpecialNotesRed}>
                        {specialNotes}
                    </Text>:
                    <Text style={styles.textWorkFormProdSpecialNotes}>
                        -
                    </Text>
                }
                {
                    specialNotes ?
                    <Text style={styles.textWorkFormProdSpecialNotes2Red}>
                        {specialNotes}
                    </Text>:
                    <Text style={styles.textWorkFormProdSpecialNotes2}>
                        -
                    </Text>
                }
                
                {
                    specialNotes ?
                    <Text style={styles.textWorkFormProdSpecialNotesNoticeLeft}>
                        ADA CATATAN KHUSUS / SPECIAL REQUEST
                    </Text>:
                    null
                }
                {
                    specialNotes ?
                    <Text style={styles.textWorkFormProdSpecialNotesNoticeRight}>
                        ADA CATATAN KHUSUS / SPECIAL REQUEST
                    </Text>:
                    null
                }

                {
                    !orderItems[i]?.inspectItem?
                    <>
                        <View key={'inspect-status'} style={{
                                ...styles.workFormInputCoverInspect0,
                                top: `${281}px`,
                                height: `${24}px`,
                            }}
                        />
                        <Text style={styles.textWorkFormInspect}>
                            TIDAK WAJIB
                        </Text>
                    </>:
                    null
                }

                {
                    orderItems[i]?.qcChecklistArray?.map((qcString, idx) => {
                        return (
                            <View key={'sd' + idx}
                                style={{
                                    ...styles.workFormInputQcChecklistContainer,
                                    top: `${325 + 18.7 * idx}px`,
                                    height: `${20}px`,
                                }}
                            >
                                <Text style={styles.workFormInputQcChecklistText}>{qcString}</Text>
                            </View>
                        );

                    })
                }

                {
                    Array.from({ length: 10 }).map((_, k) => {
                        const measValue = orderItems[i].clothingMeasurementsForItem?.[k]?.clothingMeasurementValueRounded;
                        const measName = orderItems[i].clothingMeasurementsForItem?.[k]?.clothingMeasurementName;
                        const tol1 = orderItems[i].clothingMeasurementsForItem?.[k]?.clothingMeasurementTol1;
                        const tol2 = orderItems[i].clothingMeasurementsForItem?.[k]?.clothingMeasurementTol2;
                        if (measValue) {
                            return (
                                <>
                                    <View key={'sd' + k}
                                        style={{
                                            ...styles.workFormInputCoverMeasTextContainer,
                                            top: `${327 + 18.7 * k}px`,
                                            height: `${10}px`,
                                        }}
                                    >
                                        <Text style={styles.workFormInputMeasText} >{measName}</Text>
                                    </View>
                                    <View key={'sd1' + k}
                                        style={{
                                            ...styles.workFormInputCoverMeasTextContainer2,
                                            top: `${327 + 18.7 * k}px`,
                                            height: `${10}px`,
                                        }}
                                    >
                                        <Text style={styles.workFormInputMeasText} >{measValue} cm</Text>
                                    </View>
                                    <View key={'sd2' + k}
                                        style={{
                                            ...styles.workFormInputCoverMeasTextContainerMini1,
                                            top: `${327 + 18.7 * k}px`,
                                            height: `${10}px`,
                                        }}
                                    >
                                        <Text style={styles.workFormInputMeasText} >{Math.round(10 * (measValue - tol1)) / 10} cm - {Math.round(10 * (measValue + tol1)) / 10} cm</Text>
                                    </View>
                                </>
                            );
                        }
                })}

                <View>
                    <Image src={workInputUrl} style={styles.qrCodeWorkInputForm} />
                </View>

                {
                    orderItems[i]?.productionDetailThreadArray?.length ? 
                    <Text style={{...styles.workFormProductionDetailText, fontSize: '0.6vw', paddingBottom: '0.3vw', left: '56.7vw', top: '2.55vh'}} key={'as-be'}>BENANG</Text>:
                    null
                }
                {
                    orderItems[i]?.productionDetailThreadArray?.map((objThread, idx) => {
                        return (
                            <Text style={{...styles.textBenang, 
                                backgroundColor: objThread?.hexColor ?? '#ffffff',
                                color: objThread?.hexColor === '#ffffff' ? '#000000' : '#ffffff',
                                top: `${4.05 + 3.2 * idx}vh`,
                            }} key={'as-' + idx}>BENANG {objThread?.kodeWarna?.toUpperCase()}</Text>
                        );
                    })
                }

                <View key={'kancinglist'}
                    style={styles.viewKancingList}
                >
                    {
                        orderItems[i]?.productionDetailButtonArray?.map((objThread, idx) => {
                            return (
                                <>
                                <Text style={{...styles.workFormProductionDetailText, fontSize: '0.6vw', paddingBottom: '0.3vw'}} key={'as' + '-' + idx}>KANCING</Text>
                                <Text style={styles.workFormProductionDetailText} key={'as' + '-' + idx}>{objThread?.namaKancing} {objThread?.kodeKancing ? '(' + objThread.kodeKancing + ')' : ''}</Text>
                                <Image src={objThread?.imageUrl} style={{width: '7vw', paddingTop: '0.5vw'}} />
                                </>
                            );
                        })
                    }
                </View>

                {/* VERSION 3.0 - Goes from top left down, then fills towards the right. */}
                {
                    orderItems[i].processesData.map((_, k) => {
                        const data = orderItems[i].processesData[k];
                        return (
                            <>
                            {
                                Array.from({ length: (data.maxPeople) }).map((_, l) => {

                                    const locationRowCounter = formFieldCounter % 5;
                                    const locationColCounter = Math.floor(formFieldCounter / 5);
                                    
                                    formFieldCounter = formFieldCounter + 1;
                                    return (<div key={'ff-' + formFieldCounter}>
                                        <View
                                            style={{
                                                ...styles.workFormInputTextContainer,
                                                top: `${88 + 82 * locationRowCounter}px`,
                                                left: `${500 + 117 * locationColCounter}px`,
                                                height: `${82 + 0.5 * locationRowCounter}px`,
                                            }}
                                        >
                                            <Text style={styles.workFormInputText} >{data.processName} ({l + 1})</Text>
                                        </View>
                                    </div>);
                                })
                            }
                            </>
                        )
                    })
                }
            </Page>
        );
    }

    return pages;
}

export const WorkInputForm = ({inputData, midstockList}) => {

    return (
    <Document>
        {WorkInputFormPages({inputData, midstockList})}
    </Document>);
}

export const OrderItemLabelsPages = ({inputData}) => {
    // console.log('TEST START PDF', JSON.stringify(inputData, null, 2));

    var orderSource: "WEBSITE" | "TOKOPEDIA" | "SHOPEE" = "WEBSITE";

    // DETERMINE CUSTOMER NAME
    var customerName = "Customer";
    if (orderSource === "WEBSITE" && inputData?.userPersonalInputData?.name) {
        customerName = inputData.userPersonalInputData.name;
    }
    if (inputData?.orderData?.paymentStatus === "capture_marketplace") {
        customerName = "Order Marketplace";
    }

    // ORDER ADDRESS
    var orderAddress: any = {
        orderId: "2023-06-05T11:36:32.716Z-kode-order-tujuan-disini",
        addressName: "Alamat Tujuan",
        address: "Alamat pengiriman barang customer",
        kotaKecamatanText: "Kota Tujuan, Kecamatan Tujuan, Provinsi Tujuan",
        kodePos: 11111,
        phoneNumber: "0878123456789",
        shipmentLabelUrl: "",
        orderIdFull: "2023-06-04T10:08:33.436Z-5368bdb0-f37f-40ec-ba4f-b",
    }

    var variableName: string;

    if (orderSource === "WEBSITE") {
        variableName = "orderId";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "addressName";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "address";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "kotaKecamatanText";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "kodePos";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "phoneNumber";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        }
        variableName = "orderIdFull";
        if (inputData?.orderData?.[variableName]) {
            orderAddress[variableName] = inputData.orderData[variableName];
        } else if (inputData?.orderData?.userSub && inputData?.orderData?.creationDateTime) {
            orderAddress[variableName] = inputData.orderData.creationDateTime + "-" + inputData.orderData.userSub;
        }
    }
    // TODO ADD FOR SHOPEE AND TOKOPEDIA ORDERS

    // THERE ARE 2 POSSIBILITIES: PERSONAL AND REGULAR SIZE.
    var measKitVariables: any = {
        createPersonalSizeUrl: 'https://www.studios.id/shop', // URL for random users
        repurchaseUrl: 'https://www.studios.id/shop', // URL for random users
        referralUrl: 'https://www.studios.id/shop', // URL for random users
        name: customerName === "Customer" ? "USER" : customerName, // Placeholder / default value
        sizeType: "personal",

        // Personal Variables
        height: 180, // Placeholder / default value
        weight: 70, // Placeholder / default value

        // Regular Variables
        regularSize: "Small (S)", // Placeholder / default value
    }
    if (orderSource === "WEBSITE") {
        const userSub = inputData?.orderData?.userSub;

        if (userSub.startsWith("tokopedia-") || userSub.startsWith("shopee-")) { // TODO SHOPEE AND TOKPED SUPPORT REMAINING
            return null;
        }

        measKitVariables.createPersonalSizeUrl = "https://www.studios.id/create-personal-size-with-kit/" + userSub;
        if (inputData?.orderData?.paymentStatus === "capture_marketplace") {
            measKitVariables.createPersonalSizeUrl = "https://www.studios.id/create-personal-size-mktplc/" + 
                inputData.orderData.creationDateTime + "-" + inputData.orderData.userSub;
        }
        qrCode.update({data: measKitVariables.createPersonalSizeUrl});

        measKitVariables.repurchaseUrl = "https://www.studios.id/repurchase-coupon-first/" + userSub;
        if (inputData?.orderData?.paymentStatus === "capture_marketplace") {
            measKitVariables.repurchaseUrl = "https://www.studios.id/repurchase-coupon-first-mktplc/" + 
                inputData.orderData.creationDateTime + "-" + inputData.orderData.userSub;
        }
        measKitVariables.referralUrl = "https://www.studios.id/referral-coupon/" + userSub;
        if (inputData?.orderData?.paymentStatus === "capture_marketplace") {
            measKitVariables.referralUrl = "https://www.studios.id/referral-coupon-mktplc/" + 
                inputData.orderData.creationDateTime + "-" + inputData.orderData.userSub;
        }

        variableName = "name";
        if (inputData?.userPersonalInputData?.[variableName]) {
            measKitVariables[variableName] = inputData.userPersonalInputData[variableName];
        }
        variableName = "sizeType";
        if (inputData?.userPersonalInputData?.[variableName]) {
            measKitVariables[variableName] = inputData.userPersonalInputData[variableName];
        }
        variableName = "height";
        if (inputData?.userPersonalInputData?.[variableName]) {
            measKitVariables[variableName] = inputData.userPersonalInputData[variableName];
        }
        variableName = "weight";
        if (inputData?.userPersonalInputData?.[variableName]) {
            measKitVariables[variableName] = inputData.userPersonalInputData[variableName];
        }
        variableName = "regularSize";
        if (inputData?.userPersonalInputData?.[variableName]) {
            measKitVariables[variableName] = inputData.userPersonalInputData[variableName];
        }
    }
    // TODO FOR SHOPEE AND TOKOPEDIA ORDERS

    const allOrderNameString = inputData?.orderData?.orderName ? inputData.orderData.orderName : "CUST";
    const defaultLabelNama = getLabelName(allOrderNameString);

    const orderItemsCutQueueSchedule = inputData?.orderData?.itemsCutQueueSchedule ?? [];
    const orderLabelNamaManualArray = inputData?.orderData?.labelNamaManualArray ?? [];

    const orderLabelNama = inputData?.userPersonalInputData?.labelNama;
    
    // ITEM LABELS
    const labelsForItems: any[] = [];
    if (inputData?.orderData?.cartProductList?.length && inputData?.orderData?.cartProductList?.length > 0) {
        for (var indexCartItem = 0; indexCartItem < inputData.orderData.cartProductList.length; indexCartItem = indexCartItem + 1) {
            var cartProductItem = inputData?.orderData?.cartProductList?.[indexCartItem];
            if (cartProductItem?.productDetail?.name && cartProductItem?.sizeType) {
                const cutScheduleCurrent = 
                    orderItemsCutQueueSchedule?.[labelsForItems.length] ? orderItemsCutQueueSchedule[labelsForItems.length] : 'ERROR';
                const labelNamaCurrent = 
                    orderLabelNamaManualArray?.[labelsForItems.length] ? orderLabelNamaManualArray[labelsForItems.length] :
                    cartProductItem?.labelNama ? cartProductItem.labelNama :
                    orderLabelNama ? orderLabelNama :
                    defaultLabelNama;

                var labelForItem = {
                    productName: cartProductItem?.productDetail?.name,
                    displayImage: cartProductItem?.productDetail?.displayImage,
                    sizeType: cartProductItem?.sizeType,
                    sizeValue: "CUSTOMER SIZE",
                    userName: customerName,
                    isMarketplaceOrder: inputData?.orderData?.paymentStatus === "capture_marketplace",
                    orderIdFullWithNumber: orderAddress.orderIdFull + "-" + String(indexCartItem).padStart(4, '0'),
                    labelNama: labelNamaCurrent,
                    clothingMeasurementsForItem: getClothingMeasurementsForItem(cartProductItem),
                    cutScheduleCurrent: cutScheduleCurrent,
                }

                if (labelForItem.sizeType === "regular"
                && cartProductItem?.regularSize
                && cartProductItem?.regularSize !== "NOTSELECTED") {
                    labelForItem.sizeValue = cartProductItem.regularSize;
                    for (var itemAmount = 0; itemAmount < cartProductItem.amount; itemAmount++) {
                        labelsForItems.push(labelForItem);
                    }
                }

                if (labelForItem.sizeType === "personal"
                && cartProductItem?.userMeasurementsForItem?.measurementName) {
                    labelForItem.sizeValue = cartProductItem.userMeasurementsForItem.measurementName;
                    if (cartProductItem?.userMeasurementsForItem?.nama) {
                        labelForItem.userName = cartProductItem.userMeasurementsForItem.nama;
                    }
                    for (var itemAmount1 = 0; itemAmount1 < cartProductItem.amount; itemAmount1++) {
                        labelsForItems.push(labelForItem);
                    }
                }
            }
        }
    }

    const jsonToPrint: any = {
        orderAddress: orderAddress,
        measKitVariables: measKitVariables,
        labelsForItems: labelsForItems,
    }

    
    console.log('TEST L customerName: ', customerName)
    console.log('TEST L orderAddress: ', orderAddress)
    console.log('TEST L measKitVariables: ', measKitVariables)
    console.log('TEST L allOrderNameString: ', allOrderNameString)
    console.log('TEST L defaultLabelNama: ', defaultLabelNama)
    console.log('TEST L orderLabelNama: ', orderLabelNama)
    console.log('TEST L jsonToPrint: ', jsonToPrint)

    console.log(JSON.stringify(jsonToPrint, null, 2));

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "Mei", "Juni",
        "Juli", "Aug", "Sep", "Okt", "Nov", "Des"];
  
    const d = new Date();
    const monthName = monthNames[d.getMonth()];
    const dateString = monthName + " " + d.getDate() + ", " + d.getFullYear();

    const pages = [];

    const measkitUrl = qrCode.toDataUrl();
    qrCode.update({data: measKitVariables.repurchaseUrl, "backgroundOptions": { "color": "#ffffff" }});
    const repurchaseUrl = qrCode.toDataUrl();
    qrCode.update({data: measKitVariables.referralUrl});
    const referralUrl = qrCode.toDataUrl();

    // First page is for measkit and the 2 coupon items.
    // We give the referral to everyone and the repurchase only to people who purchased one item below 170k
    if (inputData?.orderData?.paidOrderCount === undefined || inputData?.orderData?.paidOrderCount === 1) {
        const giveRepurchaseCoupon = ((inputData?.orderData?.cartProductList?.length ?? 0) < 2) && inputData?.orderData?.totalCartAmount < 170000;

        // 8 Days from Purchase
        const repurchaseDateStringISO = new Date(new Date(inputData?.orderData?.creationDateTime).getTime() + 8 * 24 * 60 * 60 * 1000).toISOString().substring(0, 10) + 'T16:59:00.000Z';
        const repurchaseDate = new Date(repurchaseDateStringISO);
        // 28 Days from Purchase
        const referralDateStringISO = new Date(new Date(inputData?.orderData?.creationDateTime).getTime() + 28 * 24 * 60 * 60 * 1000).toISOString().substring(0, 10) + 'T16:59:00.000Z';
        const referralDate = new Date(referralDateStringISO);

        var hari = ['Minggu', 'Senin','Selasa','Rabu','Kamis','Jumat','Sabtu'].map((objItem) => objItem.toUpperCase());
        var bulan = ['Januari','Februari','Maret','April','Mei','Juni','Juli','Agustus','September','Oktober','November','Desember'].map((objItem) => objItem.toUpperCase());

        const repurchaseString = hari[repurchaseDate.getUTCDay()] + ', ' + repurchaseDateStringISO.substring(8, 10) + ' ' + bulan[Number(repurchaseDateStringISO.substring(5, 7))] + ' ' + repurchaseDateStringISO.substring(0, 4); 
        const referralString = hari[referralDate.getUTCDay()] + ', ' + referralDateStringISO.substring(8, 10) + ' ' + bulan[Number(referralDateStringISO.substring(5, 7))] + ' ' + referralDateStringISO.substring(0, 4); 

        pages.push(
        <Page size="A4" orientation="portrait" key={("page" + i)}>
            <Image src="https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/Stiker_Label_Depan_V1.png" style={styles.pageBackground}/>
            <View>
                <Image src={measkitUrl} style={styles.qrCode} />
            </View>
            <View style={styles.viewMeasurementKit}>
                <Text style={styles.namaMeasurementKit} wrap={false}>{measKitVariables.name}</Text>
                <Text style={styles.subtextTanggalMeasurementKit} wrap={false}>tanggal {dateString}</Text>
            </View>
            <View style={styles.viewKeteranganMeasurementKitThreeLines}>
                <Text style={styles.subtextKeteranganMeasurementKit}>Scan QR code untuk membuka profil personal size kamu!</Text>
            </View> 

            {
                giveRepurchaseCoupon ?
                <>
                    <View>
                        <Image src={repurchaseUrl} style={styles.qrCodeRepurchase} />
                    </View>
                    <View style={styles.viewRepurchase}>
                        <Text style={styles.textRepurchase} wrap={false}>{repurchaseString}</Text>
                    </View>
                </>
                : null
            }

            <View>
                <Image src={referralUrl} style={styles.qrCodeReferral} />
            </View>
            <View style={styles.viewReferral}>
                <Text style={styles.textReferral} wrap={false}>{referralString}</Text>
            </View>
        </Page>);
    }

    for (var i = 0; i < labelsForItems.length; i = i + 2) {

        const objectItem1 = labelsForItems?.[i];
        const objectItem2 = labelsForItems?.[i + 1];

        // Create fetch list
        var fetchItem1 = "VV Bahan ";
        if (inputData?.inventoryRequestData?.itemsFetchList?.[i]) {
            for (var itemNeeded of Object.keys(inputData?.inventoryRequestData?.itemsFetchList?.[i])) {
                fetchItem1 += itemNeeded + " ambil " + inputData?.inventoryRequestData?.itemsFetchList?.[i]?.[itemNeeded] + ", ";
            }
        } else {
            fetchItem1 = "";
        }
        var fetchItem2 = "^^ Bahan ";
        if (inputData?.inventoryRequestData?.itemsFetchList?.[i + 1]) {
            for (var itemNeeded2 of Object.keys(inputData?.inventoryRequestData?.itemsFetchList?.[i + 1])) {
                fetchItem2 += itemNeeded2 + " : " + inputData?.inventoryRequestData?.itemsFetchList?.[i + 1]?.[itemNeeded2] + ", ";
            }
        } else {
            fetchItem2 = "";
        }

        pages.push(
        <Page size="A4" orientation="portrait" key={("page" + i)}>
            <Image src="https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/Stiker_Label_Item_V2.png" style={styles.pageBackground}/>

            {
                objectItem1?.displayImage ?
                <Image src={objectItem1.displayImage} style={styles.product1Photo} />:
                null
            }
            {
                objectItem2?.displayImage ?
                <Image src={objectItem2.displayImage} style={styles.product2Photo} />:
                null
            }

            <LabelItem objectItem={objectItem1} stylingLabel={styles.itemLabel1}/>
            <LabelItem objectItem={objectItem2} stylingLabel={styles.itemLabel2}/>
            <LabelFixItem objectItem={objectItem1} stylingLabel={styles.itemFixLabel1}/>
            <LabelFixItem objectItem={objectItem2} stylingLabel={styles.itemFixLabel2}/>
            {/* <LabelItemShrink objectItem={objectItem1} stylingLabel={styles.itemLabelShrink1}/> Commented, not necessary */}
            <LabelItemShrink objectItem={objectItem2} stylingLabel={styles.itemLabelShrink2}/>
        </Page>);
    }

    return pages;
}

const OrderItemLabels = ({inputData}) => {

    return (
    <Document>
        {OrderItemLabelsPages({inputData})}
    </Document>);
}

export default OrderItemLabels;

// FOR VISUALIZATION AND DEVELOPMENT PURPOSES
export const PDFViewBrowser = () => {
    return (
        <PDFViewer style={styles.pdfViewBrowser}>
            <OrderItemLabels inputData={{
            "inventoryRequestData": {
                "itemsFetchList": [
                    {
                    "midstockSmartTeeLightweightBlack-MS-L": 1
                    },
                    {
                    "midstockSmartTeeLightweightBlack-MS-XXL": 1
                    },
                    {
                    "midstockPoloVarsityNavyBlue-SizeGroup2-M-L": 1
                    }
                    ],
            },
            "orderData": {
                "phoneNumber": "087813028340",
                "shipmentStatus": "NOT SHIPPED",
                "shipmentPrice": 11500,
                "orderName": "Mikael Harseno Subianto",
                "cartProductList": [
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": {
                         "adjustedMeasurements": {
                          "lebarBahu": 46,
                          "lingkarDada": 95,
                          "lingkarLeher": 38,
                          "lingkarLenganBisep": 30,
                          "lingkarLenganPergelangan": 17.8,
                          "lingkarPerut": 95,
                          "lingkarPinggul": 95,
                          "panjangBaju": 69,
                          "panjangLenganPanjang": 63
                         }
                        }
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": {
                         "adjustedMeasurements": {
                          "lebarBahu": 46,
                          "lingkarDada": 95,
                          "lingkarLeher": 38,
                          "lingkarLenganBisep": 30,
                          "lingkarLenganPergelangan": 17.8,
                          "lingkarPerut": 95,
                          "lingkarPinggul": 95,
                          "panjangBaju": 69,
                          "panjangLenganPanjang": 63
                         }
                        }
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    }
                ],
                "orderId": "2023-06-04T10:08:33.436Z-5368bdb0-f37f-40ec-ba4f-bf",
                "shipmentTrackingNumber": "",
                "addressName": "Jl Alamanda X Blok I 10 No 16",
                "stock": "PURCHASED",
                "totalCartAmount": 142000,
                "address": "Jl. Lamper Krajaner Lor, Kec. Semarang Sel., Kota Semarang, Jawa Tenya No.27, Lamper Lor, Kec. Semarang Sel., Kota Semarang, Jawa Tengah",
                "userSub": "5368bdb0-f37f-40ec-ba4f-bf07006815c2",
                "totalPaymentAmount": 153500,
                "paymentStatus": "settlement",
                "creationDateTime": "2023-06-04T10:08:33.436Z",
                "kodePos": 50249,
                "kotaKecamatanText": "Kota Semarang, JAWA TENGAH, Semarang",
                "destinationObject": {
                    "province": "BANTEN",
                    "city": "Kota Tangerang Selatan",
                    "subdistrict": "Serpong Utara",
                    "destination_code": "TGR10060"
                },
                "estimasiPengiriman": "1 - 2 hari",
                "paidOrderCount": 1,
            },
            "userPersonalInputData": {
                "height": 175,
                "totalViewCount": 76,
                "hasBeenPrinted": true,
                "hasBeenPrintedDateTime": "2023-06-08T16:36:47.761Z",
                "bodyType": "inverted_triangle",
                "sizeType": "personal",
                "labelNama": "MOHAM",
                "name": "Mo2ham Qais",
                "weight": 73,
                "userSub": "5368bdb0-f37f-40ec-ba4f-bf07006815c2",
                "age": 26
            }
        }} />
        </PDFViewer>
    )
}
export const PDFViewBrowserShipment = () => {
    return (
        <PDFViewer style={styles.pdfViewBrowser}>
            <OrderShippingLabel isLong={false} inputData={{
            "orderData": {
                "phoneNumber": "087813028340",
                "shipmentStatus": "NOT SHIPPED",
                "shipmentPrice": 11500,
                "cartProductList": [
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    },
                    {
                        "sizeType": "regular",
                        "measurementIsBodyMeasurement": false,
                        "amount": 1,
                        "measurementCreationDateTime": "NOTSELECTED",
                        "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                        "regularSize": "Large (L)",
                        "productDetail": {
                            "displayImageHover": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                            "productBackendVersion": "v4.0",
                            "productId": "2023-04-01T03:02:15.511ZBlackModernPolo",
                            "originalPrice": 156000,
                            "color": "black",
                            "description": "Dengan design kerah yang modern dan young, Modern Polo dari Studio S bagus untuk semua acara kasual maupun business casual.",
                            "isComingAgainSoon": false,
                            "showToUser": true,
                            "defaultFitType": "RegularFit",
                            "productImages": [
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-1.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-2.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-4.jpg",
                                "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-3.jpg"
                            ],
                            "discountedPrice": 142000,
                            "material": "cvc",
                            "displayImage": "https://images-far-east.s3.ap-southeast-1.amazonaws.com/products/2023-04-01T030215.511ZBlackModernPolo/ModernPolo-Black-5.jpg",
                            "name": "Black Modern Polo in really black things",
                            "isSoldOut": false,
                            "fitTypes": [
                                "RegularFit"
                            ],
                            "clothingType": "PoloShirt",
                            "category": "polo-shirt",
                            "measurementNeeded": [
                                "panjangBaju",
                                "lingkarDada",
                                "lingkarPerut",
                                "lingkarPinggul",
                                "lebarBahu",
                                "lingkarLenganBisep",
                                "lingkarLeher"
                            ]
                        },
                        "fitType": "RegularFit",
                        "clothingType": "PoloShirt",
                        "userMeasurementsForItem": "NOTSELECTED"
                    }
                ],
                "orderId": "2023-06-04T10:08:33.436Z-5368bdb0-f37f-40ec-ba4f-bf",
                "shipmentTrackingNumber": "",
                "addressName": "Jl Alamanda X Blok I 10 No 16",
                "stock": "PURCHASED",
                "totalCartAmount": 142000,
                "address": "Clover Residence (Kamar 208, atas nama Vincent) Jl. Prof. DR. Satrio No.248, RT.1/RW.6, Kuningan, Karet Kuningan, Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12940",
                "userSub": "5368bdb0-f37f-40ec-ba4f-bf07006815c2",
                "totalPaymentAmount": 153500,
                "paymentStatus": "settlement",
                "creationDateTime": "2023-06-04T10:08:33.436Z",
                "kodePos": 50249,
                "kotaKecamatanText": "Kota Semarang, JAWA TENGAH, Semarang",
                "destinationObject": {
                    "province": "BANTEN",
                    "city": "Kota Tangerang Selatan",
                    "subdistrict": "Serpong Utara",
                    "destination_code": "TGR10060"
                },
                "estimasiPengiriman": "1 - 2 hari"
            },
            "userPersonalInputData": {
                "height": 175,
                "totalViewCount": 76,
                "hasBeenPrinted": true,
                "hasBeenPrintedDateTime": "2023-06-08T16:36:47.761Z",
                "bodyType": "inverted_triangle",
                "sizeType": "personal",
                "labelNama": "WAYAN",
                "name": "I wayan gede Sukabawa",
                "weight": 73,
                "userSub": "5368bdb0-f37f-40ec-ba4f-bf07006815c2",
                "age": 26
            }
        }} />
        </PDFViewer>
    )
}
export const PDFViewBrowserCourier = () => {
    return (
        <PDFViewer style={styles.pdfViewBrowser}>
            <OrderCourierLabel inputData={{
            "orderData": {
                "userSub": "eddfcc39-0bf1-4260-95ac-f6249704a053",
                "creationDateTime": "2023-12-31T07:00:49.963Z",
                "address": "Jl Giri Loka3 Jl. Lamarang Sel., Kota Semarang, Jawa Tenya No.27, Lamper Lor, Kec. Semarang Sel., Kota Semarang, Jawa Tengah Jl. Lamper Krajaner Lor, Kec. Semarang Sel., Kota Semarang, Jawa Tenya No.27, Lamper Lor, Kec. Semarang Sel., Kota Semarang, Jawa Tengah Jl. Lamper Krajaner Lor, Kec. Semarang Sel., Kota Semarang, Jawa Tenya No.27, Lamper Lor, Kec. Semarang Sel., Kota Semarang, Jawa Tengah",
                "addressName": "Rumah Feni",
                "cartProductList": [
                 {
                  "amount": 1,
                  "clothingType": "Kaos",
                  "fitType": "SlimFit",
                  "measurementCreationDateTime": "NOTSELECTED",
                  "measurementIsBodyMeasurement": false,
                  "productDetail": {
                   "category": "basic-tshirt",
                   "clothingType": "Kaos",
                   "color": "grey",
                   "defaultFitType": "SlimFit",
                   "description": "Smart Tee dengan Smart knit yang halus dilengkapi material yang lightweight buat kamu selalu sejuk dan ringan. Cocok untuk gaya yang minimalis dan tampil lebih smart.",
                   "discountedPrice": 132000,
                   "displayImage": "https://files-far-east.s3.ap-southeast-1.amazonaws.com/product-image/2023-10-KnitTeeCollection-SmartTeeLightweightGrey/LightweightSmartTeeInAnchorGrey_MidShot_Compressed.jpg",
                   "displayImageHover": "https://files-far-east.s3.ap-southeast-1.amazonaws.com/product-image/2023-10-KnitTeeCollection-SmartTeeLightweightGrey/LightweightSmartTeeInAnchorGrey_MidShot_Compressed.jpg",
                   "fitTypes": [
                    "SlimFit"
                   ],
                   "isComingAgainSoon": false,
                   "isSoldOut": false,
                   "material": "cvc",
                   "measurementNeeded": [
                    "lebarBahu",
                    "lingkarDada",
                    "lingkarPerut",
                    "lingkarPinggul",
                    "panjangBaju",
                    "lingkarLenganBisep",
                    "lingkarLeher"
                   ],
                   "name": "Lightweight Smart Tee in Anchor Grey",
                   "originalPrice": 155000,
                   "productBackendVersion": "v4.0",
                   "productId": "2023-10-KnitTeeCollection-SmartTeeLightweightGrey",
                   "productImages": [
                    "https://files-far-east.s3.ap-southeast-1.amazonaws.com/product-image/2023-10-KnitTeeCollection-SmartTeeLightweightGrey/LightweightSmartTeeInAnchorGrey_MidShot_Compressed.jpg",
                    "https://files-far-east.s3.ap-southeast-1.amazonaws.com/product-image/2023-10-KnitTeeCollection-SmartTeeLightweightGrey/LightweightSmartTeeInAnchorGrey_CloseUp3_Compressed.jpg",
                    "https://files-far-east.s3.ap-southeast-1.amazonaws.com/product-image/2023-10-KnitTeeCollection-SmartTeeLightweightGrey/LightweightSmartTeeInAnchorGrey_CloseUp2_Compressed.jpg",
                    "https://files-far-east.s3.ap-southeast-1.amazonaws.com/product-image/2023-10-KnitTeeCollection-SmartTeeLightweightGrey/LightweightSmartTeeInAnchorGrey_MidShotBack_Compressed.jpg",
                    "https://files-far-east.s3.ap-southeast-1.amazonaws.com/product-image/2023-10-KnitTeeCollection-SmartTeeLightweightGrey/LightweightSmartTeeInAnchorGrey_CloseUp1_Compressed.jpg"
                   ],
                   "showToUser": true
                  },
                  "productId": "2023-10-KnitTeeCollection-SmartTeeLightweightGrey",
                  "regularSize": "Large (L)",
                  "sizeType": "regular",
                  "userMeasurementsForItem": {
                   "adjustedMeasurements": {
                    "lebarBahu": 48,
                    "lingkarDada": 102,
                    "lingkarLeher": 41,
                    "lingkarLenganBisep": 31.25,
                    "lingkarLenganPergelangan": 19.4,
                    "lingkarPerut": 102,
                    "lingkarPinggul": 102,
                    "panjangBaju": 71,
                    "panjangLenganPanjang": 64
                   },
                   "nama": "Mikael Harseno",
                   "regularSize": "Large (L)",
                   "sizeType": "regular"
                  }
                 }
                ],
                "courierSelectionObject": {
                 "cod": true,
                 "cost": "8000",
                 "cut_off_time": null,
                 "drop": false,
                 "etd": "1-2",
                 "force_insurance": false,
                 "group": "regular",
                 "insurance": "0",
                 "service": "jne",
                 "service_name": "SAP Satria Reg",
                 "service_type": "UDRREG",
                 "setting": {
                  "cod_fee": "0.03",
                  "insurance_add_cost": 0,
                  "insurance_fee": "0.002",
                  "minimum_cod_fee": "3000"
                 }
                },
                "courierWeight": 1000,
                "destinationKiriminAjaObject": {
                 "kabupaten": "Kota Tangerang Selatan",
                 "kabupaten_id": 457,
                 "kecamatan": "Serpong Utara",
                 "kecamatan_id": 6315,
                 "kode_pos": "15323",
                 "provinsi": "Banten",
                 "provinsi_id": 3
                },
                "destinationObject": {},
                "estimasiPengiriman": "1-2",
                "kabupaten": "Kota Tangerang Selatan",
                "kecamatan": "Serpong Utara",
                "kodePos": 15311,
                "kotaKecamatanText": "Serpong Utara, Kota Tangerang Selatan, Banten 15311",
                "orderAllKey": "ALLORDER",
                "orderId": "2023-12-31T07:00:49.963Z-eddfcc39-0b",
                "orderIdFull": "2023-12-31T07:00:49.963Z-eddfcc39-0bf1-4260-95ac-f6249704a053",
                "orderName": "Mikael Harseno",
                "orderTrackingDetails": {
                 "userSub": "eddfcc39-0bf1-4260-95ac-f6249704a053",
                 "email": "mikaelharseno@gmail.com",
                 "fbc": "fb.0.1692252340737.PAAaapxuyhkrDzrYfOR4q7tZ3RNVFs3gcutrcBVDmlsAsaVsj7b3ln8Bl2kto_aem_AabXiZA-vGWvtnS4gIQhQbD6Qs9VsfoAn_n3o3RtJq5B9X9A0QVPZH5ElnoaERjp4jYCm9OzD6jR08Q94YffjujX",
                 "fbp": "fb.0.1690732963469.598790903",
                 "phoneNumber": "6287813028340"
                },
                "orderType": "ORDER",
                "paymentStatus": "unpaid",
                "phoneNumber": "+6287813028340",
                "provinsi": "Banten",
                "shipmentPrice": 8000,
                "shipmentStatus": "BELUM MULAI",
                "shipmentTrackingNumber": "",
                "stock": "SUBTRACTED",
                "totalCartAmount": 132000,
                "totalPaymentAmount": 132000
            }
        }} />
        </PDFViewer>
    )
}